import NotFound from "assets/images/classes/generic/notfound.png";
//general
import WhiteDamage from "assets/images/classes/generic/whitedamage.png";
import Slam from "assets/images/classes/generic/slam.png";
import Sweep from "assets/images/classes/generic/sweep.png";
import Cunning1 from "assets/images/classes/generic/cunningstrike1.png";
import Cunning2 from "assets/images/classes/generic/cunningstrike2.png";
import Cunning3 from "assets/images/classes/generic/cunningstrike3.png";
import Cunning4 from "assets/images/classes/generic/cunningstrike4.png";
import Cunning5 from "assets/images/classes/generic/cunningstrike5.png";
import Cunning6 from "assets/images/classes/generic/cunningstrike6.png";

import EnragingStrike1 from "assets/images/classes/generic/enragingstrike1.png";
import EnragingStrike2 from "assets/images/classes/generic/enragingstrike2.png";
import EnragingStrike3 from "assets/images/classes/generic/enragingstrike3.png";

import EnragingWound1 from "assets/images/classes/generic/enragingwound1.png";

import BrutalEnragingStrike1 from "assets/images/classes/generic/brutalenragingstrike1.png";
import BrutalEnragingStrike2 from "assets/images/classes/generic/brutalenragingstrike2.png";
import BrutalEnragingStrike3 from "assets/images/classes/generic/brutalenragingstrike3.png";

import BrutalEnragingWound1 from "assets/images/classes/generic/brutalenragingwound1.png";
import ViciousStrike1 from "assets/images/classes/generic/viciousstrike1.png";
import ViciousStrike2 from "assets/images/classes/generic/viciousstrike2.png";

//cc
import Fatality from "assets/images/classes/generic/fatality.png";
import FearImmunity from "assets/images/classes/generic/fearimmunity.png";
import KnockbackImmunity from "assets/images/classes/generic/knockbackimmunity.png";
import RecentlyImpaired from "assets/images/classes/generic/recentlyimpaired.png";
import RootImmunity from "assets/images/classes/generic/rootimmunity.png";
import SilenceImmunity from "assets/images/classes/generic/silenceimmunity.png";
import SnareImmunity from "assets/images/classes/generic/snareimmunity.png";
import StunImmunity from "assets/images/classes/generic/stunimmunity.png";

//debuffs
import ElementalRuin from "assets/images/classes/generic/elementalruin.png";
import ElementalTorment from "assets/images/classes/generic/elementaltorment.png";
import ElementalWrack from "assets/images/classes/generic/elementalwrack.png";
import PhysicalRuin from "assets/images/classes/generic/physicalruin.png";
import PhysicalTorment from "assets/images/classes/generic/physicaltorment.png";
import PhysicalWrack from "assets/images/classes/generic/physicalwrack.png";
import SpiritualRuin from "assets/images/classes/generic/spiritualruin.png";
import SpiritualTorment from "assets/images/classes/generic/spiritualtorment.png";
import SpiritualWrack from "assets/images/classes/generic/spiritualwrack.png";

//priest
import etherdischarge from "assets/images/classes/priest/etherdischarge.png";
import saintlymartyr from "assets/images/classes/priest/saintlymartyr.png";
import saintlywarrior from "assets/images/classes/priest/saintlywarrior.png";
import shroudofthegods from "assets/images/classes/priest/shroudofthegods.png";
import vengeanceofthegods from "assets/images/classes/priest/vengeanceofthegods.png";
import celestialgaze from "assets/images/classes/priest/celestialgaze.png";

//rogue
import agilemind from "assets/images/classes/rogue/agilemind.png";
import ambush from "assets/images/classes/rogue/ambush.png";
import brutality from "assets/images/classes/rogue/brutality.png";
import escapeartist from "assets/images/classes/rogue/escapeartist.png";
import excellentbalance from "assets/images/classes/rogue/excellentbalance.png";
import mountaineer from "assets/images/classes/rogue/mountaineer.png";
import secondwind from "assets/images/classes/rogue/secondwind.png";
import trickery from "assets/images/classes/rogue/trickery.png";
import wiles from "assets/images/classes/rogue/wiles.png";

//soldier
import burningvigor from "assets/images/classes/soldier/burningvigor.png";
import cunningdefletction from "assets/images/classes/soldier/cunningdefletction.png";
import defensivestance from "assets/images/classes/soldier/defensivestance.png";
import frenzystance from "assets/images/classes/soldier/frenzystance.png";
import goad from "assets/images/classes/soldier/goad.png";
import goadmob from "assets/images/classes/soldier/goadmob.png";
import hatefulstrikes from "assets/images/classes/soldier/hatefulstrikes.png";
import surginghealth from "assets/images/classes/soldier/surginghealth.png";
import volcanicrage from "assets/images/classes/soldier/volcanicrage.png";

//mage
import darkmeditation from "assets/images/classes/mage/darkmeditation.png";
import misdirection from "assets/images/classes/mage/misdirection.png";
import purge from "assets/images/classes/mage/purge.png";
import tomeoferlik from "assets/images/classes/mage/tomeoferlik.png";

//assassin
import assassinaccelerated from "assets/images/classes/assassin/accelerated.png"
import assassinarcanebacklash from "assets/images/classes/assassin/arcanebacklash.png"
import assassinatrophy from "assets/images/classes/assassin/atrophy.png"
import assassinavatarofdeath from "assets/images/classes/assassin/avatarofdeath.png"
import assassinbanefulvenom from "assets/images/classes/assassin/banefulvenom.png"
import assassinbanefulvenomfeat from "assets/images/classes/assassin/banefulvenomfeat.png"
import assassinbewilder from "assets/images/classes/assassin/bewilder.png"
import assassinblindside from "assets/images/classes/assassin/blindside.png"
import assassinburdentobear from "assets/images/classes/assassin/burdentobear.png"
import assassincastration from "assets/images/classes/assassin/castration.png"
import assassincatspaw from "assets/images/classes/assassin/catspaw.png"
import assassinchokingpowder from "assets/images/classes/assassin/chokingpowder.png"
import assassincoverofdusk from "assets/images/classes/assassin/coverofdusk.png"
import assassincrimsonlotuspollen from "assets/images/classes/assassin/crimsonlotuspollen.png"
import assassincripplingweakness from "assets/images/classes/assassin/cripplingweakness.png"
import assassincrystallizedlotusextract from "assets/images/classes/assassin/crystallizedlotusextract.png"
import assassincurseofthelotus from "assets/images/classes/assassin/curseofthelotus.png"
import assassindanceofdeath from "assets/images/classes/assassin/danceofdeath.png"
import assassindarkweapons from "assets/images/classes/assassin/darkweapons.png"
import assassindeathsgaze from "assets/images/classes/assassin/deathsgaze.png"
import assassindeathwhirlwind from "assets/images/classes/assassin/deathwhirlwind.png"
import assassindisfigure from "assets/images/classes/assassin/disfigure.png"
import assassindreadvenom from "assets/images/classes/assassin/dreadvenom.png"
import assassindreadweapon from "assets/images/classes/assassin/dreadweapon.png"
import assassindullpain from "assets/images/classes/assassin/dullpain.png"
import assassinessencedetonation from "assets/images/classes/assassin/essencedetonation.png"
import assassinfacestab from "assets/images/classes/assassin/facestab.png"
import assassinfleshrot from "assets/images/classes/assassin/fleshrot.png"
import assassinflurryofblows from "assets/images/classes/assassin/flurryofblows.png"
import assassinfromthedarkness from "assets/images/classes/assassin/fromthedarkness.png"
import assassingravesblossom from "assets/images/classes/assassin/gravesblossom.png"
import assassingrimcorruption1 from "assets/images/classes/assassin/grimcorruption1.png"
import assassingrimcorruption2 from "assets/images/classes/assassin/grimcorruption2.png"
import assassingrimcorruption3 from "assets/images/classes/assassin/grimcorruption3.png"
import assassingrimcorruption4 from "assets/images/classes/assassin/grimcorruption4.png"
import assassingrimcorruption5 from "assets/images/classes/assassin/grimcorruption5.png"
import assassinimpedeessence from "assets/images/classes/assassin/impedeessence.png"
import assassinimpedelife from "assets/images/classes/assassin/impedelife.png"
import assassinimpedelife2 from "assets/images/classes/assassin/impedelife2.png"
import assassinkidneyshots from "assets/images/classes/assassin/kidneyshots.png"
import assassinlethargy1 from "assets/images/classes/assassin/lethargy1.png"
import assassinlethargy2 from "assets/images/classes/assassin/lethargy2.png"
import assassinlethargy3 from "assets/images/classes/assassin/lethargy3.png"
import assassinlotuscoateddart from "assets/images/classes/assassin/lotuscoateddart.png"
import assassinlotusoverdose from "assets/images/classes/assassin/lotusoverdose.png"
import assassinlotusoverload from "assets/images/classes/assassin/lotusoverload.png"
import assassinlotustoxindeadlyvenom from "assets/images/classes/assassin/lotustoxindeadlyvenom.png";
import assassinlotusweapon from "assets/images/classes/assassin/lotusweapon.png"
import assassinmasterassassin from "assets/images/classes/assassin/masterassassin.png"
import assassinnecrosis from "assets/images/classes/assassin/necrosis.png"
import assassinnecroticempowerment from "assets/images/classes/assassin/necroticempowerment.png"
import assassinopportunisticstrike from "assets/images/classes/assassin/opportunisticstrike.png"
import assassinpoisonedblades from "assets/images/classes/assassin/poisonedblades.png"
import assassinsinsoftheflesh from "assets/images/classes/assassin/sinsoftheflesh.png"
import assassinslowdeathstrike1 from "assets/images/classes/assassin/slowdeathstrike1.png"
import assassinslowdeathstrike2 from "assets/images/classes/assassin/slowdeathstrike2.png"
import assassinslowdeathstrike3 from "assets/images/classes/assassin/slowdeathstrike3.png"
import assassinslowdeathstrike4 from "assets/images/classes/assassin/slowdeathstrike4.png"
import assassinslowdeathstrike5 from "assets/images/classes/assassin/slowdeathstrike5.png"
import assassinsnapkick from "assets/images/classes/assassin/snapkick.png"
import assassinsoulcorruption from "assets/images/classes/assassin/soulcorruption.png"
import assassinsoulstrike from "assets/images/classes/assassin/soulstrike.png"
import assassinspiritofnightfall from "assets/images/classes/assassin/spiritofnightfall.png"
import assassinswiftstrikes1 from "assets/images/classes/assassin/swiftstrikes1.png"
import assassinswiftstrikes10 from "assets/images/classes/assassin/swiftstrikes10.png"
import assassinswiftstrikes2 from "assets/images/classes/assassin/swiftstrikes2.png"
import assassinswiftstrikes3 from "assets/images/classes/assassin/swiftstrikes3.png"
import assassinswiftstrikes4 from "assets/images/classes/assassin/swiftstrikes4.png"
import assassinswiftstrikes5 from "assets/images/classes/assassin/swiftstrikes5.png"
import assassinswiftstrikes6 from "assets/images/classes/assassin/swiftstrikes6.png"
import assassinswiftstrikes7 from "assets/images/classes/assassin/swiftstrikes7.png"
import assassinswiftstrikes9 from "assets/images/classes/assassin/swiftstrikes9.png"
import assassinswitfstrikes8 from "assets/images/classes/assassin/switfstrikes8.png"
import assassinvampyricnature from "assets/images/classes/assassin/vampyricnature.png"
import assassinvilecorruption from "assets/images/classes/assassin/vilecorruption.png"
//barbarian
import barbarianarcanemarauder from "assets/images/classes/barbarian/arcanemarauder.png"
import barbarianarmageddonfalls from "assets/images/classes/barbarian/armageddonfalls.png"
import barbarianatthegates from "assets/images/classes/barbarian/atthegates.png"
import barbarianbackinthefray from "assets/images/classes/barbarian/backinthefray.png"
import barbarianblitz from "assets/images/classes/barbarian/blitz.png"
import barbarianbloodfrenzy from "assets/images/classes/barbarian/bloodfrenzy.png"
import barbarianbloodfury from "assets/images/classes/barbarian/bloodfury.png"
import barbarianbloodragestance from "assets/images/classes/barbarian/bloodragestance.png"
import barbarianboneshatter from "assets/images/classes/barbarian/boneshatter.png"
import barbarianbutcher1 from "assets/images/classes/barbarian/butcher1.png"
import barbarianbutcher10 from "assets/images/classes/barbarian/butcher10.png"
import barbarianbutcher2 from "assets/images/classes/barbarian/butcher2.png"
import barbarianbutcher3 from "assets/images/classes/barbarian/butcher3.png"
import barbarianbutcher4 from "assets/images/classes/barbarian/butcher4.png"
import barbarianbutcher5 from "assets/images/classes/barbarian/butcher5.png"
import barbarianbutcher6 from "assets/images/classes/barbarian/butcher6.png"
import barbarianbutcher7 from "assets/images/classes/barbarian/butcher7.png"
import barbarianbutcher8 from "assets/images/classes/barbarian/butcher8.png"
import barbarianbutcher9 from "assets/images/classes/barbarian/butcher9.png"
import barbarianclobber1 from "assets/images/classes/barbarian/clobber1.png"
import barbarianclobber2 from "assets/images/classes/barbarian/clobber2.png"
import barbarianclobber3 from "assets/images/classes/barbarian/clobber3.png"
import barbarianclobber4 from "assets/images/classes/barbarian/clobber4.png"
import barbarianclobber5 from "assets/images/classes/barbarian/clobber5.png"
import barbarianconcussion from "assets/images/classes/barbarian/concussion.png"
import barbariancycloneofsteel1 from "assets/images/classes/barbarian/cycloneofsteel1.png"
import barbariancycloneofsteel10 from "assets/images/classes/barbarian/cycloneofsteel10.png"
import barbariancycloneofsteel2 from "assets/images/classes/barbarian/cycloneofsteel2.png"
import barbariancycloneofsteel3 from "assets/images/classes/barbarian/cycloneofsteel3.png"
import barbariancycloneofsteel4 from "assets/images/classes/barbarian/cycloneofsteel4.png"
import barbariancycloneofsteel5 from "assets/images/classes/barbarian/cycloneofsteel5.png"
import barbariancycloneofsteel6 from "assets/images/classes/barbarian/cycloneofsteel6.png"
import barbariancycloneofsteel7 from "assets/images/classes/barbarian/cycloneofsteel7.png"
import barbariancycloneofsteel8 from "assets/images/classes/barbarian/cycloneofsteel8.png"
import barbariancycloneofsteel9 from "assets/images/classes/barbarian/cycloneofsteel9.png"
import barbariandanceofdeath from "assets/images/classes/barbarian/danceofdeath.png"
import barbariandecapitation from "assets/images/classes/barbarian/decapitation.png"
import barbariandetermination from "assets/images/classes/barbarian/determination.png"
import barbariandevastation from "assets/images/classes/barbarian/devastation.png"
import barbarianearthshatter from "assets/images/classes/barbarian/earthshatter.png"
import barbarianeyesofmadness from "assets/images/classes/barbarian/eyesofmadness.png"
import barbarianfinishingblow from "assets/images/classes/barbarian/finishingblow.png"
import barbarianhaste from "assets/images/classes/barbarian/haste.png"
import barbarianimpale from "assets/images/classes/barbarian/impale.png"
import barbarianjaggedcut1 from "assets/images/classes/barbarian/jaggedcut1.png"
import barbarianjaggedcut2 from "assets/images/classes/barbarian/jaggedcut2.png"
import barbarianjaggedcut3 from "assets/images/classes/barbarian/jaggedcut3.png"
import barbarianjaggedcut4 from "assets/images/classes/barbarian/jaggedcut4.png"
import barbariannoescape from "assets/images/classes/barbarian/noescape.png"
import barbarianoverpower from "assets/images/classes/barbarian/overpower.png"
import barbarianparalysis from "assets/images/classes/barbarian/paralysis.png"
import barbarianpredatoryinstincts from "assets/images/classes/barbarian/predatoryinstincts.png"
import barbarianrampaginghorde from "assets/images/classes/barbarian/rampaginghorde.png"
import barbarianreaverstance from "assets/images/classes/barbarian/reaverstance.png"
import barbarianreverseswing from "assets/images/classes/barbarian/reverseswing.png"
import barbarianrupturearmor from "assets/images/classes/barbarian/rupturearmor.png"
import barbariansavagefury from "assets/images/classes/barbarian/savagefury.png"
import barbarianscatterfoes from "assets/images/classes/barbarian/scatterfoes.png"
import barbariansever from "assets/images/classes/barbarian/sever.png"
import barbarianshrapnel from "assets/images/classes/barbarian/shrapnel.png"
import barbarianstaggeringblow1 from "assets/images/classes/barbarian/staggeringblow1.png"
import barbarianstaggeringblow2 from "assets/images/classes/barbarian/staggeringblow2.png"
import barbarianstaggeringblow3 from "assets/images/classes/barbarian/staggeringblow3.png"
import barbarianstaggeringblow4 from "assets/images/classes/barbarian/staggeringblow4.png"
import barbarianstunningpunch1 from "assets/images/classes/barbarian/stunningpunch1.png"
import barbarianstunningpunch2 from "assets/images/classes/barbarian/stunningpunch2.png"
import barbarianstunningpunch3 from "assets/images/classes/barbarian/stunningpunch3.png"
import barbarianstunningpunch4 from "assets/images/classes/barbarian/stunningpunch4.png"
import barbarianstunningpunch5 from "assets/images/classes/barbarian/stunningpunch5.png"
import barbarianswarmfighter from "assets/images/classes/barbarian/swarmfighter.png"
import barbarianthirstforblood from "assets/images/classes/barbarian/thirstforblood.png"
import barbariantoolsathand from "assets/images/classes/barbarian/toolsathand.png"
import barbariantoomanytocount from "assets/images/classes/barbarian/toomanytocount.png"
import barbarianunstablemind from "assets/images/classes/barbarian/unstablemind.png"
import barbarianupheavel from "assets/images/classes/barbarian/upheavel.png"
import barbarianwelcomingdeath from "assets/images/classes/barbarian/welcomingdeath.png"
import barbarianwhatittakes from "assets/images/classes/barbarian/whatittakes.png"
import barbarianwhirlwind1 from "assets/images/classes/barbarian/whirlwind1.png"
import barbarianwhirlwind2 from "assets/images/classes/barbarian/whirlwind2.png"
import barbarianwhirlwind3 from "assets/images/classes/barbarian/whirlwind3.png"
import barbarianwhirlwind4 from "assets/images/classes/barbarian/whirlwind4.png"
import barbarianwhirlwind5 from "assets/images/classes/barbarian/whirlwind5.png"
import barbarianwithoutwarning from "assets/images/classes/barbarian/withoutwarning.png"
import barbarianwreckarmor1 from "assets/images/classes/barbarian/wreckarmor1.png"
import barbarianwreckarmor2 from "assets/images/classes/barbarian/wreckarmor2.png"
import barbarianwreckarmor3 from "assets/images/classes/barbarian/wreckarmor3.png"
import barbarianwreckarmor4 from "assets/images/classes/barbarian/wreckarmor4.png"
//bearshaman
import bearshamanadrenalinesurge from "assets/images/classes/bearshaman/adrenalinesurge.png"
import bearshamanarcticslumber from "assets/images/classes/bearshaman/arcticslumber.png"
import bearshamanawakening from "assets/images/classes/bearshaman/awakening.png"
import bearshamanbalanceofnature from "assets/images/classes/bearshaman/balanceofnature.png"
import bearshamanbewilder from "assets/images/classes/bearshaman/bewilder.png"
import bearshamanbloodflow from "assets/images/classes/bearshaman/bloodflow.png"
import bearshamanbloodthirst from "assets/images/classes/bearshaman/bloodthirst.png"
import bearshamanbloodwarrior from "assets/images/classes/bearshaman/bloodwarrior.png"
import bearshamanboomingroar from "assets/images/classes/bearshaman/boomingroar.png"
import bearshamancensuringstrike1 from "assets/images/classes/bearshaman/censuringstrike1.png"
import bearshamancensuringstrike2 from "assets/images/classes/bearshaman/censuringstrike2.png"
import bearshamancensuringstrike3 from "assets/images/classes/bearshaman/censuringstrike3.png"
import bearshamanclawsofcorruption from "assets/images/classes/bearshaman/clawsofcorruption.png"
import bearshamanclawsoflife from "assets/images/classes/bearshaman/clawsoflife.png"
import bearshamanclawsofstone from "assets/images/classes/bearshaman/clawsofstone.png"
import bearshamanclawsofthereaper from "assets/images/classes/bearshaman/clawsofthereaper.png"
import bearshamancrusharmor1 from "assets/images/classes/bearshaman/crusharmor1.png"
import bearshamancrusharmor2 from "assets/images/classes/bearshaman/crusharmor2.png"
import bearshamancrusharmor3 from "assets/images/classes/bearshaman/crusharmor3.png"
import bearshamancrusharmor4 from "assets/images/classes/bearshaman/crusharmor4.png"
import bearshamanethertheft from "assets/images/classes/bearshaman/ethertheft.png"
import bearshamanferalgrowl from "assets/images/classes/bearshaman/feralgrowl.png"
import bearshamanferocioussmack from "assets/images/classes/bearshaman/ferocioussmack.png"
import bearshamanferocioussmack2 from "assets/images/classes/bearshaman/ferocioussmack2.png"
import bearshamanferocioussmack3 from "assets/images/classes/bearshaman/ferocioussmack3.png"
import bearshamanferocioussmack4 from "assets/images/classes/bearshaman/ferocioussmack4.png"
import bearshamanferocioussmack5 from "assets/images/classes/bearshaman/ferocioussmack5.png"
import bearshamanfiercerecovery from "assets/images/classes/bearshaman/fiercerecovery.png"
import bearshamangraceofnature from "assets/images/classes/bearshaman/graceofnature.png"
import bearshamanhindermovement1 from "assets/images/classes/bearshaman/hindermovement1.png"
import bearshamanhindermovement2 from "assets/images/classes/bearshaman/hindermovement2.png"
import bearshamaninternalbleed1 from "assets/images/classes/bearshaman/internalbleed1.png"
import bearshamaninternalbleed2 from "assets/images/classes/bearshaman/internalbleed2.png"
import bearshamaninternalbleed3 from "assets/images/classes/bearshaman/internalbleed3.png"
import bearshamaninternalbleed4 from "assets/images/classes/bearshaman/internalbleed4.png"
import bearshamanironhide from "assets/images/classes/bearshaman/ironhide.png"
import bearshamanlifetap from "assets/images/classes/bearshaman/lifetap.png"
import bearshamanlycanthropicbite from "assets/images/classes/bearshaman/lycanthropicbite.png"
import bearshamanmanifestationofregrowth from "assets/images/classes/bearshaman/manifestationofregrowth.png"
import bearshamanmanifestationofspirit from "assets/images/classes/bearshaman/manifestationofspirit.png"
import bearshamanmanifestationoftheforest from "assets/images/classes/bearshaman/manifestationoftheforest.png"
import bearshamanmanifestationofthesun from "assets/images/classes/bearshaman/manifestationofthesun.png"
import bearshamanmanifestationofwinter from "assets/images/classes/bearshaman/manifestationofwinter.png"
import bearshamanmaul from "assets/images/classes/bearshaman/maul.png"
import bearshamannaturesrevenge from "assets/images/classes/bearshaman/naturesrevenge.png"
import bearshamannatureswrath from "assets/images/classes/bearshaman/natureswrath.png"
import bearshamanposionedhide from "assets/images/classes/bearshaman/posionedhide.png"
import bearshamanrampage from "assets/images/classes/bearshaman/rampage.png"
import bearshamanrenewal from "assets/images/classes/bearshaman/renewal.png"
import bearshamanruneofaggression from "assets/images/classes/bearshaman/runeofaggression.png"
import bearshamanruneofgrounding from "assets/images/classes/bearshaman/runeofgrounding.png"
import bearshamanruneofresilience from "assets/images/classes/bearshaman/runeofresilience.png"
import bearshamanruneofresistance from "assets/images/classes/bearshaman/runeofresistance.png"
import bearshamanscarredhide from "assets/images/classes/bearshaman/scarredhide.png"
import bearshamanshrewdblow1 from "assets/images/classes/bearshaman/shrewdblow1.png"
import bearshamanshrewdblow2 from "assets/images/classes/bearshaman/shrewdblow2.png"
import bearshamanshrewdblow3 from "assets/images/classes/bearshaman/shrewdblow3.png"
import bearshamanshrewdblow4 from "assets/images/classes/bearshaman/shrewdblow4.png"
import bearshamanshrewdblow5 from "assets/images/classes/bearshaman/shrewdblow5.png"
import bearshamanshrewdblow6 from "assets/images/classes/bearshaman/shrewdblow6.png"
import bearshamansleuthofbears from "assets/images/classes/bearshaman/sleuthofbears.png"
import bearshamanspiritofthebear from "assets/images/classes/bearshaman/spiritofthebear.png"
import bearshamanspiritofyggdrasil from "assets/images/classes/bearshaman/spiritofyggdrasil.png"
import bearshamanstonehide from "assets/images/classes/bearshaman/stonehide.png"
import bearshamansurgeofbile from "assets/images/classes/bearshaman/surgeofbile.png"
import bearshamanursinebond from "assets/images/classes/bearshaman/ursinebond.png"
import bearshamanursinebrawl1 from "assets/images/classes/bearshaman/ursinebrawl1.png"
import bearshamanursinebrawl2 from "assets/images/classes/bearshaman/ursinebrawl2.png"
import bearshamanursinebrawl3 from "assets/images/classes/bearshaman/ursinebrawl3.png"
import bearshamanursinebrawl4 from "assets/images/classes/bearshaman/ursinebrawl4.png"
import bearshamanursinecrush from "assets/images/classes/bearshaman/ursinecrush.png"
import bearshamanursinerush from "assets/images/classes/bearshaman/ursinerush.png"
import bearshamanvisionofthesky from "assets/images/classes/bearshaman/visionofthesky.png"
import bearshamanwintersbite from "assets/images/classes/bearshaman/wintersbite.png"

//conqueror
import conquerorannihilate from "assets/images/classes/conqueror/annihilate.png"
import conquerorartofwar from "assets/images/classes/conqueror/artofwar.png"
import conquerorassail from "assets/images/classes/conqueror/assail.png"
import conqueroratdeathsdoor from "assets/images/classes/conqueror/atdeathsdoor.png"
import conquerorbatteraside1 from "assets/images/classes/conqueror/batteraside1.png"
import conquerorbatteraside2 from "assets/images/classes/conqueror/batteraside2.png"
import conquerorbatteraside3 from "assets/images/classes/conqueror/batteraside3.png"
import conquerorbatteraside4 from "assets/images/classes/conqueror/batteraside4.png"
import conquerorbatteraside5 from "assets/images/classes/conqueror/batteraside5.png"
import conquerorbattlefieldcommander from "assets/images/classes/conqueror/battlefieldcommander.png"
import conquerorberserkinspiration from "assets/images/classes/conqueror/berserkinspiration.png"
import conquerorbesiege from "assets/images/classes/conqueror/besiege.png"
import conquerorbladeweave from "assets/images/classes/conqueror/bladeweave.png"
import conquerorblessedblade from "assets/images/classes/conqueror/blessedblade.png"
import conquerorblessedconquest from "assets/images/classes/conqueror/blessedconquest.png"
import conquerorbloodbath1 from "assets/images/classes/conqueror/bloodbath1.png"
import conquerorbloodbath2 from "assets/images/classes/conqueror/bloodbath2.png"
import conquerorbloodbath3 from "assets/images/classes/conqueror/bloodbath3.png"
import conquerorbloodbath4 from "assets/images/classes/conqueror/bloodbath4.png"
import conquerorbloodbath5 from "assets/images/classes/conqueror/bloodbath5.png"
import conquerorbloodbath6 from "assets/images/classes/conqueror/bloodbath6.png"
import conquerorbloodbath7 from "assets/images/classes/conqueror/bloodbath7.png"
import conquerorbloodlust from "assets/images/classes/conqueror/bloodlust.png"
import conquerorbloodyhack1 from "assets/images/classes/conqueror/bloodyhack1.png"
import conquerorbloodyhack2 from "assets/images/classes/conqueror/bloodyhack2.png"
import conquerorbloodyhack3 from "assets/images/classes/conqueror/bloodyhack3.png"
import conquerorbloodyhack4 from "assets/images/classes/conqueror/bloodyhack4.png"
import conquerorbloodyhack5 from "assets/images/classes/conqueror/bloodyhack5.png"
import conquerorbloodyhack6 from "assets/images/classes/conqueror/bloodyhack6.png"
import conquerorbreach1 from "assets/images/classes/conqueror/breach1.png"
import conquerorbreach2 from "assets/images/classes/conqueror/breach2.png"
import conquerorbreach3 from "assets/images/classes/conqueror/breach3.png"
import conquerorbreach4 from "assets/images/classes/conqueror/breach4.png"
import conquerorbreakthrough from "assets/images/classes/conqueror/breakthrough.png"
import conquerorburstofaggression from "assets/images/classes/conqueror/burstofaggression.png"
import conquerorcripplinglaceration from "assets/images/classes/conqueror/cripplinglaceration.png"
import conquerorcrushingonslaught from "assets/images/classes/conqueror/crushingonslaught.png"
import conquerorcunning from "assets/images/classes/conqueror/cunning.png"
import conquerordeepwounds from "assets/images/classes/conqueror/deepwounds.png"
import conquerordefiance from "assets/images/classes/conqueror/defiance.png"
import conquerordisciplinewillofmettle from "assets/images/classes/conqueror/disciplinewillofmettle.png"
import conquerordisciplinewillofonslaught from "assets/images/classes/conqueror/disciplinewillofonslaught.png"
import conquerordisciplinewillofvivification from "assets/images/classes/conqueror/disciplinewillofvivification.png"
import conquerorfeintattack1 from "assets/images/classes/conqueror/feintattack1.png"
import conquerorfeintattack2 from "assets/images/classes/conqueror/feintattack2.png"
import conquerorfeintattack3 from "assets/images/classes/conqueror/feintattack3.png"
import conquerorfeintattack4 from "assets/images/classes/conqueror/feintattack4.png"
import conquerorfeintattack5 from "assets/images/classes/conqueror/feintattack5.png"
import conquerorfeintattack6 from "assets/images/classes/conqueror/feintattack6.png"
import conquerorfeintattack7 from "assets/images/classes/conqueror/feintattack7.png"
import conquerorfeintattack8 from "assets/images/classes/conqueror/feintattack8.png"
import conquerorfeintattack9 from "assets/images/classes/conqueror/feintattack9.png"
import conquerorflashingdefense from "assets/images/classes/conqueror/flashingdefense.png"
import conquerorformationtheburningstandard from "assets/images/classes/conqueror/formationtheburningstandard.png"
import conquerorformationthefortifyingstandard from "assets/images/classes/conqueror/formationthefortifyingstandard.png"
import conquerorformationtherestoringstandard from "assets/images/classes/conqueror/formationtherestoringstandard.png"
import conquerorfuriousinspiration from "assets/images/classes/conqueror/furiousinspiration.png"
import conquerorfuriousresurgence from "assets/images/classes/conqueror/furiousresurgence.png"
import conquerorfuriousstrikes from "assets/images/classes/conqueror/furiousstrikes.png"
import conquerorgranttechnique from "assets/images/classes/conqueror/granttechnique.png"
import conquerorguardofdancingsteel1 from "assets/images/classes/conqueror/guardofdancingsteel1.png"
import conquerorguardofdancingsteel2 from "assets/images/classes/conqueror/guardofdancingsteel2.png"
import conquerorguardofdancingsteel3 from "assets/images/classes/conqueror/guardofdancingsteel3.png"
import conquerorguardofdancingsteel4 from "assets/images/classes/conqueror/guardofdancingsteel4.png"
import conquerorhailoffuriousstrikes1 from "assets/images/classes/conqueror/hailoffuriousstrikes1.png"
import conquerorhailoffuriousstrikes2 from "assets/images/classes/conqueror/hailoffuriousstrikes2.png"
import conquerorhailoffuriousstrikes3 from "assets/images/classes/conqueror/hailoffuriousstrikes3.png"
import conquerorhailoffuriousstrikes4 from "assets/images/classes/conqueror/hailoffuriousstrikes4.png"
import conquerorhailoffuriousstrikes5 from "assets/images/classes/conqueror/hailoffuriousstrikes5.png"
import conquerorhailoffuriousstrikes6 from "assets/images/classes/conqueror/hailoffuriousstrikes6.png"
import conquerorheroiccall from "assets/images/classes/conqueror/heroiccall.png"
import conquerorlacerate from "assets/images/classes/conqueror/lacerate.png"
import conquerorlightningsteel from "assets/images/classes/conqueror/lightningsteel.png"
import conquerorlumberinghulk from "assets/images/classes/conqueror/lumberinghulk.png"
import conqueroronelastpush from "assets/images/classes/conqueror/onelastpush.png"
import conquerorovercometheodds from "assets/images/classes/conqueror/overcometheodds.png"
import conqueroroverwhelm1 from "assets/images/classes/conqueror/overwhelm1.png"
import conqueroroverwhelm2 from "assets/images/classes/conqueror/overwhelm2.png"
import conqueroroverwhelm3 from "assets/images/classes/conqueror/overwhelm3.png"
import conqueroroverwhelm4 from "assets/images/classes/conqueror/overwhelm4.png"
import conqueroroverwhelm5 from "assets/images/classes/conqueror/overwhelm5.png"
import conqueroroverwhelm6 from "assets/images/classes/conqueror/overwhelm6.png"
import conquerorplantbanner from "assets/images/classes/conqueror/plantbanner.png"
import conquerorrally from "assets/images/classes/conqueror/rally.png"
import conquerorrendflesh from "assets/images/classes/conqueror/rendflesh.png"
import conquerorresurgence from "assets/images/classes/conqueror/resurgence.png"
import conquerorretaliation from "assets/images/classes/conqueror/retaliation.png"
import conquerorruthlessassault from "assets/images/classes/conqueror/ruthlessassault.png"
import conquerorthroatslash from "assets/images/classes/conqueror/throatslash.png"
import conquerorwarlord from "assets/images/classes/conqueror/warlord.png"
import conquerorwhirlwind from "assets/images/classes/conqueror/whirlwind.png"

//darktemplar
import darktemplarairofdeath from "assets/images/classes/darktemplar/airofdeath.png"
import darktemplarasoulforourfeast1 from "assets/images/classes/darktemplar/asoulforourfeast1.png"
import darktemplarasoulforourfeast2 from "assets/images/classes/darktemplar/asoulforourfeast2.png"
import darktemplarasoulforourfeast3 from "assets/images/classes/darktemplar/asoulforourfeast3.png"
import darktemplarasoulforourfeast4 from "assets/images/classes/darktemplar/asoulforourfeast4.png"
import darktemplarasoulforourfeast5 from "assets/images/classes/darktemplar/asoulforourfeast5.png"
import darktemplarauraofdreadfury from "assets/images/classes/darktemplar/auraofdreadfury.png"
import darktemplarauraofinfusion from "assets/images/classes/darktemplar/auraofinfusion.png"
import darktemplarblightedsoul from "assets/images/classes/darktemplar/blightedsoul.png"
import darktemplarblightedtouch from "assets/images/classes/darktemplar/blightedtouch.png"
import darktemplarbloodforaid1 from "assets/images/classes/darktemplar/bloodforaid1.png"
import darktemplarbloodforaid2 from "assets/images/classes/darktemplar/bloodforaid2.png"
import darktemplarbloodforaid3 from "assets/images/classes/darktemplar/bloodforaid3.png"
import darktemplarbloodforaid4 from "assets/images/classes/darktemplar/bloodforaid4.png"
import darktemplarbloodforaid5 from "assets/images/classes/darktemplar/bloodforaid5.png"
import darktemplarbloodforblood from "assets/images/classes/darktemplar/bloodforblood.png"
import darktemplarbloodhex from "assets/images/classes/darktemplar/bloodhex.png"
import darktemplarbloodpact from "assets/images/classes/darktemplar/bloodpact.png"
import darktemplarbloodshroud from "assets/images/classes/darktemplar/bloodshroud.png"
import darktemplarconsumingbulwark from "assets/images/classes/darktemplar/consumingbulwark.png"
import darktemplarcorruption from "assets/images/classes/darktemplar/corruption.png"
import darktemplarcovenantofarms from "assets/images/classes/darktemplar/covenantofarms.png"
import darktemplarcovenantofinvulnerability from "assets/images/classes/darktemplar/covenantofinvulnerability.png"
import darktemplarcovenantofpestilence from "assets/images/classes/darktemplar/covenantofpestilence.png"
import darktemplarcovenantofvengeance from "assets/images/classes/darktemplar/covenantofvengeance.png"
import darktemplarcovenantsofdeath from "assets/images/classes/darktemplar/covenantsofdeath.png"
import darktemplarcrimsonsuccor from "assets/images/classes/darktemplar/crimsonsuccor.png"
import darktemplarcrystallizedchaos from "assets/images/classes/darktemplar/crystallizedchaos.png"
import darktemplarcurseofgwahlur from "assets/images/classes/darktemplar/curseofgwahlur.png"
import darktemplardarkburden from "assets/images/classes/darktemplar/darkburden.png"
import darktemplardeathlord from "assets/images/classes/darktemplar/deathlord.png"
import darktemplardoomingpresence from "assets/images/classes/darktemplar/doomingpresence.png"
import darktemplardrainessence from "assets/images/classes/darktemplar/drainessence.png"
import darktemplardrainlife from "assets/images/classes/darktemplar/drainlife.png"
import darktemplardreadshadow from "assets/images/classes/darktemplar/dreadshadow.png"
import darktemplaretherreap from "assets/images/classes/darktemplar/etherreap.png"
import darktemplarhexmarkedsoul from "assets/images/classes/darktemplar/hexmarkedsoul.png"
import darktemplarlifeleech1 from "assets/images/classes/darktemplar/lifeleech1.png"
import darktemplarlifeleech2 from "assets/images/classes/darktemplar/lifeleech2.png"
import darktemplarlifeleech3 from "assets/images/classes/darktemplar/lifeleech3.png"
import darktemplarlifeleech4 from "assets/images/classes/darktemplar/lifeleech4.png"
import darktemplarlifeleech5 from "assets/images/classes/darktemplar/lifeleech5.png"
import darktemplarlifeleech6 from "assets/images/classes/darktemplar/lifeleech6.png"
import darktemplarmartyrdom from "assets/images/classes/darktemplar/martyrdom.png"
import darktemplarmindshatter from "assets/images/classes/darktemplar/mindshatter.png"
import darktemplarmindwrack from "assets/images/classes/darktemplar/mindwrack.png"
import darktemplarmysticalbane1 from "assets/images/classes/darktemplar/mysticalbane1.png"
import darktemplarmysticalbane2 from "assets/images/classes/darktemplar/mysticalbane2.png"
import darktemplarmysticalbane3 from "assets/images/classes/darktemplar/mysticalbane3.png"
import darktemplarmysticalbane4 from "assets/images/classes/darktemplar/mysticalbane4.png"
import darktemplarmysticalbane5 from "assets/images/classes/darktemplar/mysticalbane5.png"
import darktemplarpactofmalacodor from "assets/images/classes/darktemplar/pactofmalacodor.png"
import darktemplarriteofblood from "assets/images/classes/darktemplar/riteofblood.png"
import darktemplarritualisticbloodshed from "assets/images/classes/darktemplar/ritualisticbloodshed.png"
import darktemplarsadisticsoul from "assets/images/classes/darktemplar/sadisticsoul.png"
import darktemplarsanguineinfusion from "assets/images/classes/darktemplar/sanguineinfusion.png"
import darktemplarscarabknight from "assets/images/classes/darktemplar/scarabknight.png"
import darktemplarsealofchaos from "assets/images/classes/darktemplar/sealofchaos.png"
import darktemplarsealofyog from "assets/images/classes/darktemplar/sealofyog.png"
import darktemplarinvulnerablesoul from "assets/images/classes/darktemplar/invulnerablesoul.png"
import darktemplarshadowedsoul from "assets/images/classes/darktemplar/shadowedsoul.png"
import darktemplarshadowhex from "assets/images/classes/darktemplar/shadowhex.png"
import darktemplarsoulbarrier from "assets/images/classes/darktemplar/soulbarrier.png"
import darktemplartalismanmastery from "assets/images/classes/darktemplar/talismanmastery.png"
import darktemplartouchofdeath from "assets/images/classes/darktemplar/touchofdeath.png"
import darktemplarunhallowedblight1 from "assets/images/classes/darktemplar/unhallowedblight1.png"
import darktemplarunhallowedblight2 from "assets/images/classes/darktemplar/unhallowedblight2.png"
import darktemplarunhallowedblight3 from "assets/images/classes/darktemplar/unhallowedblight3.png"
import darktemplarunhallowedblight4 from "assets/images/classes/darktemplar/unhallowedblight4.png"
import darktemplarunwillingsacrifice from "assets/images/classes/darktemplar/unwillingsacrifice.png"
import darktemplarvoidofmadness from "assets/images/classes/darktemplar/voidofmadness.png"
import darktemplarzoneofgluttony from "assets/images/classes/darktemplar/zoneofgluttony.png"

//demonologist
import demonologistabaddoronwarrior from "assets/images/classes/demonologist/abaddoronwarrior.png"
import demonologistagonizingjolts from "assets/images/classes/demonologist/agonizingjolts.png"
import demonologistamassedflames from "assets/images/classes/demonologist/amassedflames.png"
import demonologistarchfiendspact from "assets/images/classes/demonologist/archfiendspact.png"
import demonologistbindingsoftheskylord from "assets/images/classes/demonologist/bindingsoftheskylord.png"
import demonologistblisteringwounds from "assets/images/classes/demonologist/blisteringwounds.png"
import demonologistbloodypactwithset from "assets/images/classes/demonologist/bloodypactwithset.png"
import demonologistboilblood from "assets/images/classes/demonologist/boilblood.png"
import demonologistbreakpact from "assets/images/classes/demonologist/breakpact.png"
import demonologistcacodemon from "assets/images/classes/demonologist/cacodemon.png"
import demonologistchaoticblast from "assets/images/classes/demonologist/chaoticblast.png"
import demonologistchargedstormchains from "assets/images/classes/demonologist/chargedstormchains.png"
import demonologistcircleofmagic from "assets/images/classes/demonologist/circleofmagic.png"
import demonologistconsumeheart from "assets/images/classes/demonologist/consumeheart.png"
import demonologistconsumingflames from "assets/images/classes/demonologist/consumingflames.png"
import demonologistcursedbyheavens from "assets/images/classes/demonologist/cursedbyheavens.png"
import demonologistcursedbyhell from "assets/images/classes/demonologist/cursedbyhell.png"
import demonologistdemonavenger from "assets/images/classes/demonologist/demonavenger.png"
import demonologistdemonfamiliar from "assets/images/classes/demonologist/demonfamiliar.png"
import demonologistdemonguardian from "assets/images/classes/demonologist/demonguardian.png"
import demonologistdemonicheart from "assets/images/classes/demonologist/demonicheart.png"
import demonologistdemonicrenewal from "assets/images/classes/demonologist/demonicrenewal.png"
import demonologistdemonicwar from "assets/images/classes/demonologist/demonicwar.png"
import demonologistdemonslave from "assets/images/classes/demonologist/demonslave.png"
import demonologistdemonwarlord from "assets/images/classes/demonologist/demonwarlord.png"
import demonologistdetonation from "assets/images/classes/demonologist/detonation.png"
import demonologistdrawforththeheart from "assets/images/classes/demonologist/drawforththeheart.png"
import demonologistdevouringflames from "assets/images/classes/demonologist/devouringflames.png"
import demonologistearthrecharge from "assets/images/classes/demonologist/earthrecharge.png"
import demonologistfierytorment from "assets/images/classes/demonologist/fierytorment.png"
import demonologistfiresofgehenna from "assets/images/classes/demonologist/firesofgehenna.png"
import demonologistgateofhell from "assets/images/classes/demonologist/gateofhell.png"
import demonologistgreaterflames from "assets/images/classes/demonologist/greaterflames.png"
import demonologisthandofdoom from "assets/images/classes/demonologist/handofdoom.png"
import demonologisthandsoftheunderworld from "assets/images/classes/demonologist/handsoftheunderworld.png"
import demonologisthellfirestream from "assets/images/classes/demonologist/hellfirestream.png"
import demonologisthellsgarden from "assets/images/classes/demonologist/hellsgarden.png"
import demonologistimpishhorde from "assets/images/classes/demonologist/impishhorde.png"
import demonologistincinerate from "assets/images/classes/demonologist/incinerate.png"
import demonologistinfernoofamher from "assets/images/classes/demonologist/infernoofamher.png"
import demonologistintenseheat from "assets/images/classes/demonologist/intenseheat.png"
import demonologistletthemburn from "assets/images/classes/demonologist/letthemburn.png"
import demonologistlivingfirestorm from "assets/images/classes/demonologist/livingfirestorm.png"
import demonologistlivingthunderstorm from "assets/images/classes/demonologist/livingthunderstorm.png"
import demonologistloreofskelos from "assets/images/classes/demonologist/loreofskelos.png"
import demonologistmysticsuppression from "assets/images/classes/demonologist/mysticsuppression.png"
import demonologistoverload from "assets/images/classes/demonologist/overload.png"
import demonologistpactofdread from "assets/images/classes/demonologist/pactofdread.png"
import demonologistpactwithset from "assets/images/classes/demonologist/pactwithset.png"
import demonologistplanarshift from "assets/images/classes/demonologist/planarshift.png"
import demonologistpossession from "assets/images/classes/demonologist/possession.png"
import demonologistprotectionofset from "assets/images/classes/demonologist/protectionofset.png"
import demonologistrenegotiation from "assets/images/classes/demonologist/renegotiation.png"
import demonologistringoffire from "assets/images/classes/demonologist/ringoffire.png"
import demonologistruinouspower from "assets/images/classes/demonologist/ruinouspower.png"
import demonologistsacrificialheart from "assets/images/classes/demonologist/sacrificialheart.png"
import demonologistshieldofinfernalflames from "assets/images/classes/demonologist/shieldofinfernalflames.png"
import demonologistshock from "assets/images/classes/demonologist/shock.png"
import demonologistshockblast from "assets/images/classes/demonologist/shockblast.png"
import demonologistshocklance from "assets/images/classes/demonologist/shocklance.png"
import demonologistshockstrike from "assets/images/classes/demonologist/shockstrike.png"
import demonologistsoulresonance from "assets/images/classes/demonologist/soulresonance.png"
import demonologiststormchains from "assets/images/classes/demonologist/stormchains.png"
import demonologistsubtleillusion from "assets/images/classes/demonologist/subtleillusion.png"
import demonologistthunderclap from "assets/images/classes/demonologist/thunderclap.png"
import demonologistunleashtheunderworld from "assets/images/classes/demonologist/unleashtheunderworld.png"
import demonologistwavesofflame from "assets/images/classes/demonologist/wavesofflame.png"
import demonologistwickedbolt from "assets/images/classes/demonologist/wickedbolt.png"

//guardian
import guardianbattlecry from "assets/images/classes/guardian/battlecry.png"
import guardianbloodyvengeance from "assets/images/classes/guardian/bloodyvengeance.png"
import guardiancalltoarms from "assets/images/classes/guardian/calltoarms.png"
import guardianchampionspirit from "assets/images/classes/guardian/championspirit.png"
import guardiancounterstike2 from "assets/images/classes/guardian/counterstike2.png"
import guardiancounterstrike1 from "assets/images/classes/guardian/counterstrike1.png"
import guardiancounterstrike3 from "assets/images/classes/guardian/counterstrike3.png"
import guardiancounterstrike4 from "assets/images/classes/guardian/counterstrike4.png"
import guardiancounterweight from "assets/images/classes/guardian/counterweight.png"
import guardiancryofhavoc from "assets/images/classes/guardian/cryofhavoc.png"
import guardiandeliberatereprisal from "assets/images/classes/guardian/deliberatereprisal.png"
import guardiandisable1 from "assets/images/classes/guardian/disable1.png"
import guardiandisable2 from "assets/images/classes/guardian/disable2.png"
import guardiandisable3 from "assets/images/classes/guardian/disable3.png"
import guardiandisable4 from "assets/images/classes/guardian/disable4.png"
import guardiandisarmingaggression from "assets/images/classes/guardian/disarmingaggression.png"
import guardiandullingblow1 from "assets/images/classes/guardian/dullingblow1.png"
import guardiandullingblow2 from "assets/images/classes/guardian/dullingblow2.png"
import guardiandullingblow3 from "assets/images/classes/guardian/dullingblow3.png"
import guardiandullingblow4 from "assets/images/classes/guardian/dullingblow4.png"
import guardiandullingblow5 from "assets/images/classes/guardian/dullingblow5.png"
import guardianflashingarc1 from "assets/images/classes/guardian/flashingarc1.png"
import guardianflashingarc2 from "assets/images/classes/guardian/flashingarc2.png"
import guardianflashingarc3 from "assets/images/classes/guardian/flashingarc3.png"
import guardianflashingarc4 from "assets/images/classes/guardian/flashingarc4.png"
import guardianflashingarc5 from "assets/images/classes/guardian/flashingarc5.png"
import guardianflashingarc6 from "assets/images/classes/guardian/flashingarc6.png"
import guardianflashingarc7 from "assets/images/classes/guardian/flashingarc7.png"
import guardianflashingarc8 from "assets/images/classes/guardian/flashingarc8.png"
import guardianflashingarc9 from "assets/images/classes/guardian/flashingarc9.png"
import guardianguard1 from "assets/images/classes/guardian/guard1.png"
import guardianguard2 from "assets/images/classes/guardian/guard2.png"
import guardianguard3 from "assets/images/classes/guardian/guard3.png"
import guardianguard4 from "assets/images/classes/guardian/guard4.png"
import guardianguard5 from "assets/images/classes/guardian/guard5.png"
import guardianguarddestroyer1 from "assets/images/classes/guardian/guarddestroyer1.png"
import guardianguarddestroyer2 from "assets/images/classes/guardian/guarddestroyer2.png"
import guardianguarddestroyer3 from "assets/images/classes/guardian/guarddestroyer3.png"
import guardianguarddestroyer4 from "assets/images/classes/guardian/guarddestroyer4.png"
import guardianimpale from "assets/images/classes/guardian/impale.png"
import guardianintimidatingshout from "assets/images/classes/guardian/intimidatingshout.png"
import guardianjuggernaut from "assets/images/classes/guardian/juggernaut.png"
import guardianlightningreflexes from "assets/images/classes/guardian/lightningreflexes.png"
import guardianmaneuverelusivedaring from "assets/images/classes/guardian/maneuverelusivedaring.png"
import guardianmaneuvermentalbarrier from "assets/images/classes/guardian/maneuvermentalbarrier.png"
import guardianmaneuverwallofsteel from "assets/images/classes/guardian/maneuverwallofsteel.png"
import guardianmasteratarms from "assets/images/classes/guardian/masteratarms.png"
import guardianmoraleboost from "assets/images/classes/guardian/moraleboost.png"
import guardianoverreach1 from "assets/images/classes/guardian/overreach1.png"
import guardianoverreach2 from "assets/images/classes/guardian/overreach2.png"
import guardianoverreach3 from "assets/images/classes/guardian/overreach3.png"
import guardianoverreach4 from "assets/images/classes/guardian/overreach4.png"
import guardianoverreach5 from "assets/images/classes/guardian/overreach5.png"
import guardianoverreach6 from "assets/images/classes/guardian/overreach6.png"
import guardianoverwhelmingshout from "assets/images/classes/guardian/overwhelmingshout.png"
import guardianplexusstrike1 from "assets/images/classes/guardian/plexusstrike1.png"
import guardianplexusstrike2 from "assets/images/classes/guardian/plexusstrike2.png"
import guardianplexusstrike3 from "assets/images/classes/guardian/plexusstrike3.png"
import guardianpowerhouse from "assets/images/classes/guardian/powerhouse.png"
import guardianprimeinitiative from "assets/images/classes/guardian/primeinitiative.png"
import guardianreckoning from "assets/images/classes/guardian/reckoning.png"
import guardianredoubt from "assets/images/classes/guardian/redoubt.png"
import guardianriposte from "assets/images/classes/guardian/riposte.png"
import guardianshieldslam from "assets/images/classes/guardian/shieldslam.png"
import guardianshieldstrike from "assets/images/classes/guardian/shieldstrike.png"
import guardianshieldsweep1 from "assets/images/classes/guardian/shieldsweep1.png"
import guardianshieldsweep2 from "assets/images/classes/guardian/shieldsweep2.png"
import guardianshieldsweep3 from "assets/images/classes/guardian/shieldsweep3.png"
import guardianshieldsweep4 from "assets/images/classes/guardian/shieldsweep4.png"
import guardianshieldsweep5 from "assets/images/classes/guardian/shieldsweep5.png"
import guardianskewer from "assets/images/classes/guardian/skewer.png"
import guardianstagger1 from "assets/images/classes/guardian/stagger1.png"
import guardianstagger2 from "assets/images/classes/guardian/stagger2.png"
import guardianstagger3 from "assets/images/classes/guardian/stagger3.png"
import guardianstagger4 from "assets/images/classes/guardian/stagger4.png"
import guardianstagger5 from "assets/images/classes/guardian/stagger5.png"
import guardianstalltheadvance from "assets/images/classes/guardian/stalltheadvance.png"
import guardianstandyourground from "assets/images/classes/guardian/standyourground.png"
import guardianstormblade from "assets/images/classes/guardian/stormblade.png"
import guardianstormstrike from "assets/images/classes/guardian/stormstrike.png"
import guardianstrikeandguard from "assets/images/classes/guardian/strikeandguard.png"
import guardianstunningcharge from "assets/images/classes/guardian/stunningcharge.png"
import guardiansubterfuge from "assets/images/classes/guardian/subterfuge.png"
import guardiansustainingwrath from "assets/images/classes/guardian/sustainingwrath.png"
import guardiantacticattack from "assets/images/classes/guardian/tacticattack.png"
import guardiantacticdefense from "assets/images/classes/guardian/tacticdefense.png"
import guardiantacticprovoke from "assets/images/classes/guardian/tacticprovoke.png"
import guardianthelaststand from "assets/images/classes/guardian/thelaststand.png"
import guardiantitanicsmash from "assets/images/classes/guardian/titanicsmash.png"
import guardianvengeanceismine from "assets/images/classes/guardian/vengeanceismine.png"

//heraldofxotli
import heraldofxotliarcaneabatement from "assets/images/classes/heraldofxotli/arcaneabatement.png"
import heraldofxotliavatarofxotli from "assets/images/classes/heraldofxotli/avatarofxotli.png"
import heraldofxotlibodyandspiritwrack1 from "assets/images/classes/heraldofxotli/bodyandspiritwrack1.png"
import heraldofxotlibodyandspiritwrack2 from "assets/images/classes/heraldofxotli/bodyandspiritwrack2.png"
import heraldofxotlibodyandspiritwrack3 from "assets/images/classes/heraldofxotli/bodyandspiritwrack3.png"
import heraldofxotlibodyandspiritwrack4 from "assets/images/classes/heraldofxotli/bodyandspiritwrack4.png"
import heraldofxotliburninghex from "assets/images/classes/heraldofxotli/burninghex.png"
import heraldofxotliburningskull from "assets/images/classes/heraldofxotli/burningskull.png"
import heraldofxotliburntodeath1 from "assets/images/classes/heraldofxotli/burntodeath1.png"
import heraldofxotliburntodeath2 from "assets/images/classes/heraldofxotli/burntodeath2.png"
import heraldofxotliburntodeath3 from "assets/images/classes/heraldofxotli/burntodeath3.png"
import heraldofxotliburntodeath4 from "assets/images/classes/heraldofxotli/burntodeath4.png"
import heraldofxotliburntodeath5 from "assets/images/classes/heraldofxotli/burntodeath5.png"
import heraldofxotliburntodeath6 from "assets/images/classes/heraldofxotli/burntodeath6.png"
import heraldofxotlichainsofanguish from "assets/images/classes/heraldofxotli/chainsofanguish.png"
import heraldofxotlicontractofprotection from "assets/images/classes/heraldofxotli/contractofprotection.png"
import heraldofxotlidemonmaw from "assets/images/classes/heraldofxotli/demonmaw.png"
import heraldofxotlidesecratingessence from "assets/images/classes/heraldofxotli/desecratingessence.png"
import heraldofxotlidreadvisage from "assets/images/classes/heraldofxotli/dreadvisage.png"
import heraldofxotlienslavingfire from "assets/images/classes/heraldofxotli/enslavingfire.png"
import heraldofxotliexultationofxotli from "assets/images/classes/heraldofxotli/exultationofxotli.png"
import heraldofxotlietherthirst from "assets/images/classes/heraldofxotli/etherthirst.png"
import heraldofxotlifeedingthepyre from "assets/images/classes/heraldofxotli/feedingthepyre.png"
import heraldofxotlifirelance from "assets/images/classes/heraldofxotli/firelance.png"
import heraldofxotlifireweapons from "assets/images/classes/heraldofxotli/fireweapons.png"
import heraldofxotliflamelash from "assets/images/classes/heraldofxotli/flamelash.png"
import heraldofxotliflametongue from "assets/images/classes/heraldofxotli/flametongue.png"
import heraldofxotlifromthebeyond from "assets/images/classes/heraldofxotli/fromthebeyond.png"
import heraldofxotlifuryofxotli from "assets/images/classes/heraldofxotli/furyofxotli.png"
import heraldofxotlihellfirebreath from "assets/images/classes/heraldofxotli/hellfirebreath.png"
import heraldofxotlihellonearth from "assets/images/classes/heraldofxotli/hellonearth.png"
import heraldofxotlihellsteps from "assets/images/classes/heraldofxotli/hellsteps.png"
import heraldofxotlihellstrikes1 from "assets/images/classes/heraldofxotli/hellstrikes1.png"
import heraldofxotlihellstrikes2 from "assets/images/classes/heraldofxotli/hellstrikes2.png"
import heraldofxotlihellstrikes3 from "assets/images/classes/heraldofxotli/hellstrikes3.png"
import heraldofxotlihellstrikes4 from "assets/images/classes/heraldofxotli/hellstrikes4.png"
import heraldofxotlihellstrikes5 from "assets/images/classes/heraldofxotli/hellstrikes5.png"
import heraldofxotlihellstrikes6 from "assets/images/classes/heraldofxotli/hellstrikes6.png"
import heraldofxotlihungerformore from "assets/images/classes/heraldofxotli/hungerformore.png"
import heraldofxotliieatyourheart from "assets/images/classes/heraldofxotli/ieatyourheart.png"
import heraldofxotliinferno from "assets/images/classes/heraldofxotli/inferno.png"
import heraldofxotliinfernocurse from "assets/images/classes/heraldofxotli/infernocurse.png"
import heraldofxotliinsanityofxotli from "assets/images/classes/heraldofxotli/insanityofxotli.png"
import heraldofxotlimoltenflesh from "assets/images/classes/heraldofxotli/moltenflesh.png"
import heraldofxotlimoltensteelslash1 from "assets/images/classes/heraldofxotli/moltensteelslash1.png"
import heraldofxotlimoltensteelslash2 from "assets/images/classes/heraldofxotli/moltensteelslash2.png"
import heraldofxotlimoltensteelslash3 from "assets/images/classes/heraldofxotli/moltensteelslash3.png"
import heraldofxotlimoltensteelslash4 from "assets/images/classes/heraldofxotli/moltensteelslash4.png"
import heraldofxotlimoltensteelslash5 from "assets/images/classes/heraldofxotli/moltensteelslash5.png"
import heraldofxotlimoltensteelslash6 from "assets/images/classes/heraldofxotli/moltensteelslash6.png"
import heraldofxotliphoenixcloak from "assets/images/classes/heraldofxotli/phoenixcloak.png"
import heraldofxotlipillarofinfernalflame1 from "assets/images/classes/heraldofxotli/pillarofinfernalflame1.png"
import heraldofxotlipillarofinfernalflame2 from "assets/images/classes/heraldofxotli/pillarofinfernalflame2.png"
import heraldofxotlipillarofinfernalflame3 from "assets/images/classes/heraldofxotli/pillarofinfernalflame3.png"
import heraldofxotliprinceofterror from "assets/images/classes/heraldofxotli/princeofterror.png"
import heraldofxotliquickeningdeath from "assets/images/classes/heraldofxotli/quickeningdeath.png"
import heraldofxotliredshadowsofxotli from "assets/images/classes/heraldofxotli/redshadowsofxotli.png"
import heraldofxotlisearingcurse from "assets/images/classes/heraldofxotli/searingcurse.png"
import heraldofxotlisearinghatred from "assets/images/classes/heraldofxotli/searinghatred.png"
import heraldofxotlispitfire from "assets/images/classes/heraldofxotli/spitfire.png"
import heraldofxotlispreadingflames from "assets/images/classes/heraldofxotli/spreadingflames.png"
import heraldofxotlithunderingflames from "assets/images/classes/heraldofxotli/thunderingflames.png"
import heraldofxotlitongueofxotli from "assets/images/classes/heraldofxotli/tongueofxotli.png"
import heraldofxotliundyinggloryofxotli from "assets/images/classes/heraldofxotli/undyinggloryofxotli.png"
import heraldofxotliwordofcommand from "assets/images/classes/heraldofxotli/wordofcommand.png"

//necromancer
import necromancerancientsoul from "assets/images/classes/necromancer/ancientsoul.png"
import necromancerblasphemedflesh from "assets/images/classes/necromancer/blasphemedflesh.png"
import necromancerblasphemousruin from "assets/images/classes/necromancer/blasphemousruin.png"
import necromancerblasphemy from "assets/images/classes/necromancer/blasphemy.png"
import necromancerbonehorde from "assets/images/classes/necromancer/bonehorde.png"
import necromancercannibalism from "assets/images/classes/necromancer/cannibalism.png"
import necromancerchill from "assets/images/classes/necromancer/chill.png"
import necromancerchillingbreath from "assets/images/classes/necromancer/chillingbreath.png"
import necromancercurseofpain from "assets/images/classes/necromancer/curseofpain.png"
import necromancerdeathschannel from "assets/images/classes/necromancer/deathschannel.png";
import necromancerdeatheater from "assets/images/classes/necromancer/deatheater.png"
import necromancerdeathgod from "assets/images/classes/necromancer/deathgod.png"
import necromancerdeathlessacolytearcanist from "assets/images/classes/necromancer/deathlessacolytearcanist.png"
import necromancerdeathlessacolytemagus from "assets/images/classes/necromancer/deathlessacolytemagus.png"
import necromancerdeathlessacolytereaper from "assets/images/classes/necromancer/deathlessacolytereaper.png"
import necromancerdeathlyblizzard from "assets/images/classes/necromancer/deathlyblizzard.png"
import necromancerdeathsterror from "assets/images/classes/necromancer/deathsterror.png"
import necromancerdecay from "assets/images/classes/necromancer/decay.png"
import necromancerdecaysofnature from "assets/images/classes/necromancer/decaysofnature.png"
import necromancerdespoilthesoul from "assets/images/classes/necromancer/despoilthesoul.png"
import necromancerdrawforththeheart from "assets/images/classes/necromancer/drawforththeheart.png"
import necromancerdreadarchmagearchmagus from "assets/images/classes/necromancer/dreadarchmagearchmagus.png"
import necromancerdreadarchmagebloodarcanist from "assets/images/classes/necromancer/dreadarchmagebloodarcanist.png"
import necromancerdreadblight from "assets/images/classes/necromancer/dreadblight.png"
import necromancerembracedeath from "assets/images/classes/necromancer/embracedeath.png"
import necromancerfleshofthewight from "assets/images/classes/necromancer/fleshofthewight.png"
import necromancerfleshtoworms from "assets/images/classes/necromancer/fleshtoworms.png"
import necromancerfreeze from "assets/images/classes/necromancer/freeze.png"
import necromancerfrenzy from "assets/images/classes/necromancer/frenzy.png"
import necromancerfrostblast from "assets/images/classes/necromancer/frostblast.png"
import necromancerfrozenhatred from "assets/images/classes/necromancer/frozenhatred.png"
import necromancerfuneralrites from "assets/images/classes/necromancer/funeralrites.png"
import necromancergangrenousstench from "assets/images/classes/necromancer/gangrenousstench.png"
import necromancergelidbones from "assets/images/classes/necromancer/gelidbones.png"
import necromancergeneralofthedead from "assets/images/classes/necromancer/generalofthedead.png"
import necromancerghoulishfeast from "assets/images/classes/necromancer/ghoulishfeast.png"
import necromancergrimcorruptor from "assets/images/classes/necromancer/grimcorruptor.png"
import necromancergrimhunger from "assets/images/classes/necromancer/grimhunger.png"
import necromancergripofdeath from "assets/images/classes/necromancer/gripofdeath.png"
import necromancerharvestsoul from "assets/images/classes/necromancer/harvestsoul.png"
import necromancericeshackle from "assets/images/classes/necromancer/iceshackle.png"
import necromancericestrike from "assets/images/classes/necromancer/icestrike.png"
import necromancerinfestation from "assets/images/classes/necromancer/infestation.png"
import necromancerlifeleech from "assets/images/classes/necromancer/lifeleech.png"
import necromancerlifestrike from "assets/images/classes/necromancer/lifestrike.png"
import necromancermarkofthedevourer from "assets/images/classes/necromancer/markofthedevourer.png"
import necromancernecroticdetonation from "assets/images/classes/necromancer/necroticdetonation.png"
import necromancernecroticpustule from "assets/images/classes/necromancer/necroticpustule.png"
import necromancernetherworlddeception from "assets/images/classes/necromancer/netherworlddeception.png"
import necromancernightmarecompanions from "assets/images/classes/necromancer/nightmarecompanions.png"
import necromancernorestforthedead from "assets/images/classes/necromancer/norestforthedead.png"
import necromanceronewithdeath from "assets/images/classes/necromancer/onewithdeath.png"
import necromancerparasiticsoulswarm from "assets/images/classes/necromancer/parasiticsoulswarm.png"
import necromancerpestilentialblasr from "assets/images/classes/necromancer/pestilentialblasr.png"
import necromancerplaguedheartcurse from "assets/images/classes/necromancer/plaguedheartcurse.png"
import necromancerplagueswarm from "assets/images/classes/necromancer/plagueswarm.png"
import necromancerquelltheether from "assets/images/classes/necromancer/quelltheether.png"
import necromancerreapthesoul from "assets/images/classes/necromancer/reapthesoul.png"
import necromancerritualofthelich from "assets/images/classes/necromancer/ritualofthelich.png"
import necromancerruinedblight from "assets/images/classes/necromancer/ruinedblight.png"
import necromancerrunedflesh from "assets/images/classes/necromancer/runedflesh.png"
import necromancersacrifice from "assets/images/classes/necromancer/sacrifice.png"
import necromancerscytheshield from "assets/images/classes/necromancer/scytheshield.png"
import necromancersetscoldhatred from "assets/images/classes/necromancer/setscoldhatred.png"
import necromancersetsruin from "assets/images/classes/necromancer/setsruin.png"
import necromancershatter from "assets/images/classes/necromancer/shatter.png"
import necromancersiphonunlife from "assets/images/classes/necromancer/siphonunlife.png"
import necromancersoulabsorption from "assets/images/classes/necromancer/soulabsorption.png"
import necromancersoulfrost from "assets/images/classes/necromancer/soulfrost.png"
import necromancersupremelich from "assets/images/classes/necromancer/supremelich.png"
import necromancertomeofepithur from "assets/images/classes/necromancer/tomeofepithur.png"
import necromancertouchofwinter from "assets/images/classes/necromancer/touchofwinter.png"
import necromancerundeadchampionslaughterwraith from "assets/images/classes/necromancer/undeadchampionslaughterwraith.png"
import necromancerundeadminionblightedone from "assets/images/classes/necromancer/undeadminionblightedone.png"
import necromancerundeadminioncorruptor from "assets/images/classes/necromancer/undeadminioncorruptor.png"
import necromancerundeadminionharvester from "assets/images/classes/necromancer/undeadminionharvester.png"
import necromancerundeadminionlifestealer from "assets/images/classes/necromancer/undeadminionlifestealer.png"
import necromancerundeadminionmutilator from "assets/images/classes/necromancer/undeadminionmutilator.png"
import necromancerundeadminionnecroticbomb from "assets/images/classes/necromancer/undeadminionnecroticbomb.png"
import necromancerunholyhands from "assets/images/classes/necromancer/unholyhands.png"
import necromancerunimaginableterror from "assets/images/classes/necromancer/unimaginableterror.png"
import necromancervoid from "assets/images/classes/necromancer/void.png"
import necromancerwalkwithdeath from "assets/images/classes/necromancer/walkwithdeath.png"
import necromancerwitheredblasphemy from "assets/images/classes/necromancer/witheredblasphemy.png"
import necromancerwitheredsoul from "assets/images/classes/necromancer/witheredsoul.png"
import necromancerwretchedheartcurse from "assets/images/classes/necromancer/wretchedheartcurse.png"
//priestofmitra
import priestofmitraarmoroffaith from "assets/images/classes/priestofmitra/armoroffaith.png"
import priestofmitraavatarofmitra from "assets/images/classes/priestofmitra/avatarofmitra.png"
import priestofmitraavertthineeyes from "assets/images/classes/priestofmitra/avertthineeyes.png"
import priestofmitrablessedsoul from "assets/images/classes/priestofmitra/blessedsoul.png"
import priestofmitrablessingofmitra from "assets/images/classes/priestofmitra/blessingofmitra.png"
import priestofmitrablisteringwounds from "assets/images/classes/priestofmitra/blisteringwounds.png"
import priestofmitraclarityofmind from "assets/images/classes/priestofmitra/clarityofmind.png"
import priestofmitracleansingfire from "assets/images/classes/priestofmitra/cleansingfire.png"
import priestofmitracondemn from "assets/images/classes/priestofmitra/condemn.png"
import priestofmitracondemnation from "assets/images/classes/priestofmitra/condemnation.png"
import priestofmitradevotionalprayer from "assets/images/classes/priestofmitra/devotionalprayer.png"
import priestofmitradivineblessing from "assets/images/classes/priestofmitra/divineblessing.png"
import priestofmitradivinevigor from "assets/images/classes/priestofmitra/divinevigor.png"
import priestofmitraemanationoflife from "assets/images/classes/priestofmitra/emanationoflife.png"
import priestofmitraemissaryofelysium from "assets/images/classes/priestofmitra/emissaryofelysium.png"
import priestofmitraexorcism from "assets/images/classes/priestofmitra/exorcism.png"
import priestofmitraeyeofjudgment from "assets/images/classes/priestofmitra/eyeofjudgment.png"
import priestofmitraglowingradiance from "assets/images/classes/priestofmitra/glowingradiance.png"
import priestofmitraguardianspirit from "assets/images/classes/priestofmitra/guardianspirit.png"
import priestofmitrahandofmitra from "assets/images/classes/priestofmitra/handofmitra.png"
import priestofmitraholyaccession from "assets/images/classes/priestofmitra/holyaccession.png"
import priestofmitraholycleansing from "assets/images/classes/priestofmitra/holycleansing.png"
import priestofmitraholystorm from "assets/images/classes/priestofmitra/holystorm.png"
import priestofmitraholyvengeance from "assets/images/classes/priestofmitra/holyvengeance.png"
import priestofmitraimmortalwrath from "assets/images/classes/priestofmitra/immortalwrath.png"
import priestofmitrainclusion from "assets/images/classes/priestofmitra/inclusion.png"
import priestofmitrainspiringlight from "assets/images/classes/priestofmitra/inspiringlight.png"
import priestofmitralanceofmitra from "assets/images/classes/priestofmitra/lanceofmitra.png"
import priestofmitralightofmitra from "assets/images/classes/priestofmitra/lightofmitra.png"
import priestofmitralightthepath from "assets/images/classes/priestofmitra/lightthepath.png"
import priestofmitralitanyofprotection from "assets/images/classes/priestofmitra/litanyofprotection.png"
import priestofmitramanifestationofmitra from "assets/images/classes/priestofmitra/manifestationofmitra.png"
import priestofmitramitrassearingeye from "assets/images/classes/priestofmitra/mitrassearingeye.png"
import priestofmitrapurificationofmitra from "assets/images/classes/priestofmitra/purificationofmitra.png"
import priestofmitrapurifyinglight from "assets/images/classes/priestofmitra/purifyinglight.png"
import priestofmitraradiance from "assets/images/classes/priestofmitra/radiance.png"
import priestofmitrarebuke from "assets/images/classes/priestofmitra/rebuke.png"
import priestofmitrareciprocalhealing from "assets/images/classes/priestofmitra/reciprocalhealing.png"
import priestofmitrareincarnation from "assets/images/classes/priestofmitra/reincarnation.png"
import priestofmitrarejuvenatinglight from "assets/images/classes/priestofmitra/rejuvenatinglight.png"
import priestofmitrarepudiate from "assets/images/classes/priestofmitra/repudiate.png"
import priestofmitrarepulse from "assets/images/classes/priestofmitra/repulse.png"
import priestofmitrasacredfire from "assets/images/classes/priestofmitra/sacredfire.png"
import priestofmitrasacredsmite from "assets/images/classes/priestofmitra/sacredsmite.png"
import priestofmitrasearinglight from "assets/images/classes/priestofmitra/searinglight.png"
import priestofmitrashieldofbrilliance from "assets/images/classes/priestofmitra/shieldofbrilliance.png"
import priestofmitrashimmeringinvocation from "assets/images/classes/priestofmitra/shimmeringinvocation.png"
import priestofmitrasmite from "assets/images/classes/priestofmitra/smite.png"
import priestofmitrasoulofmitra from "assets/images/classes/priestofmitra/soulofmitra.png"
import priestofmitraspiritualfeedback from "assets/images/classes/priestofmitra/spiritualfeedback.png"
import priestofmitrasustainingthefaith from "assets/images/classes/priestofmitra/sustainingthefaith.png"
import priestofmitraunknown1 from "assets/images/classes/priestofmitra/unknown1.png"
import priestofmitrawanderingdisciple from "assets/images/classes/priestofmitra/wanderingdisciple.png"
import priestofmitrawaveoflife from "assets/images/classes/priestofmitra/waveoflife.png"

//ranger
import rangeradvangtageabsoluteprecision from "assets/images/classes/ranger/advangtageabsoluteprecision.png"
import rangeradvantagefireattack from "assets/images/classes/ranger/advantagefireattack.png"
import rangeradvantagefocusedfire from "assets/images/classes/ranger/advantagefocusedfire.png"
import rangeradvantagemisdirection from "assets/images/classes/ranger/advantagemisdirection.png"
import rangeradvantagerecuperation from "assets/images/classes/ranger/advantagerecuperation.png"
import rangeradvantagesharpenedweapons from "assets/images/classes/ranger/advantagesharpenedweapons.png"
import rangeradvantageshatteringattack from "assets/images/classes/ranger/advantageshatteringattack.png"
import rangerarmorripper1 from "assets/images/classes/ranger/armorripper1.png"
import rangerarmorripper2 from "assets/images/classes/ranger/armorripper2.png"
import rangerarmorripper3 from "assets/images/classes/ranger/armorripper3.png"
import rangerbleedingpuncture1 from "assets/images/classes/ranger/bleedingpuncture1.png"
import rangerbleedingpuncture2 from "assets/images/classes/ranger/bleedingpuncture2.png"
import rangerbleedingpuncture3 from "assets/images/classes/ranger/bleedingpuncture3.png"
import rangerbleedingpuncture4 from "assets/images/classes/ranger/bleedingpuncture4.png"
import rangerboobytrap from "assets/images/classes/ranger/boobytrap.png"
import rangerclout from "assets/images/classes/ranger/clout.png"
import rangerconcussiveblast from "assets/images/classes/ranger/concussiveblast.png"
import rangercripple1 from "assets/images/classes/ranger/cripple1.png"
import rangercripple2 from "assets/images/classes/ranger/cripple2.png"
import rangercripple3 from "assets/images/classes/ranger/cripple3.png"
import rangercrossfire from "assets/images/classes/ranger/crossfire.png"
import rangerdeadlydraw from "assets/images/classes/ranger/deadlydraw.png"
import rangerdeftstabs1 from "assets/images/classes/ranger/deftstabs1.png"
import rangerdeftstabs2 from "assets/images/classes/ranger/deftstabs2.png"
import rangerdeftstabs3 from "assets/images/classes/ranger/deftstabs3.png"
import rangerevasiveaction from "assets/images/classes/ranger/evasiveaction.png"
import rangerfancyfootwork from "assets/images/classes/ranger/fancyfootwork.png"
import rangerfiretrap from "assets/images/classes/ranger/firetrap.png"
import rangerflamebarrage from "assets/images/classes/ranger/flamebarrage.png"
import rangerhuntinghawk from "assets/images/classes/ranger/huntinghawk.png"
import rangerimmolation from "assets/images/classes/ranger/immolation.png"
import rangerincendiaryshot from "assets/images/classes/ranger/incendiaryshot.png"
import rangerjarringshot from "assets/images/classes/ranger/jarringshot.png"
import rangerlegholdtrap from "assets/images/classes/ranger/legholdtrap.png"
import rangerlinebreaker from "assets/images/classes/ranger/linebreaker.png"
import rangermarkedfordeath from "assets/images/classes/ranger/markedfordeath.png"
import rangermarkedtarget from "assets/images/classes/ranger/markedtarget.png"
import rangermastertrapper from "assets/images/classes/ranger/mastertrapper.png"
import rangerpenetratingshot1 from "assets/images/classes/ranger/penetratingshot1.png"
import rangerpenetratingshot2 from "assets/images/classes/ranger/penetratingshot2.png"
import rangerpenetratingshot3 from "assets/images/classes/ranger/penetratingshot3.png"
import rangerpenetratingshot4 from "assets/images/classes/ranger/penetratingshot4.png"
import rangerpenetratingshot5 from "assets/images/classes/ranger/penetratingshot5.png"
import rangerpindown1 from "assets/images/classes/ranger/pindown1.png"
import rangerpindown2 from "assets/images/classes/ranger/pindown2.png"
import rangerpindown3 from "assets/images/classes/ranger/pindown3.png"
import rangerpindown4 from "assets/images/classes/ranger/pindown4.png"
import rangerpitchpot from "assets/images/classes/ranger/pitchpot.png"
import rangerexhaustingtraps from "assets/images/classes/ranger/exhaustingtraps.png"
import rangerpointblankshot from "assets/images/classes/ranger/pointblankshot.png"
import rangerpuncture from "assets/images/classes/ranger/puncture.png"
import rangerquickshot1 from "assets/images/classes/ranger/quickshot1.png"
import rangerquickshot2 from "assets/images/classes/ranger/quickshot2.png"
import rangerquickshot3 from "assets/images/classes/ranger/quickshot3.png"
import rangerquickshot4 from "assets/images/classes/ranger/quickshot4.png"
import rangerquickshot5 from "assets/images/classes/ranger/quickshot5.png"
import rangerrecentlyusedadvantage from "assets/images/classes/ranger/recentlyusedadvantage.png"
import rangerrendingstrikes from "assets/images/classes/ranger/rendingstrikes.png"
import rangerrunningshot from "assets/images/classes/ranger/runningshot.png"
import rangershieldbash from "assets/images/classes/ranger/shieldbash.png"
import rangersulfurousburst from "assets/images/classes/ranger/sulfurousburst.png"
import rangertracking from "assets/images/classes/ranger/tracking.png"
import rangervigor from "assets/images/classes/ranger/vigor.png"

//tempestofset
import tempestofsetbloodmana from "assets/images/classes/tempestofset/bloodmana.png"
import tempestofsetcalllightning from "assets/images/classes/tempestofset/calllightning.png"
import tempestofsetchargedblast from "assets/images/classes/tempestofset/chargedblast.png"
import tempestofsetcoalesceether from "assets/images/classes/tempestofset/coalesceether.png"
import tempestofsetcobrasnare from "assets/images/classes/tempestofset/cobrasnare.png"
import tempestofsetcoilsoftheserpent from "assets/images/classes/tempestofset/coilsoftheserpent.png"
import tempestofsetcolumnlightning from "assets/images/classes/tempestofset/columnlightning.png"
import tempestofsetconstriction from "assets/images/classes/tempestofset/constriction.png"
import tempestofsetcurseofset from "assets/images/classes/tempestofset/curseofset.png"
import tempestofsetcycloneofset from "assets/images/classes/tempestofset/cycloneofset.png"
import tempestofsetdamnationofset from "assets/images/classes/tempestofset/damnationofset.png"
import tempestofsetelementalfury from "assets/images/classes/tempestofset/elementalfury.png"
import tempestofseteyeofthestorm from "assets/images/classes/tempestofset/eyeofthestorm.png"
import tempestofseteyesofset from "assets/images/classes/tempestofset/eyesofset.png"
import tempestofsetfaithfulofset from "assets/images/classes/tempestofset/faithfulofset.png"
import tempestofsetfaithinset from "assets/images/classes/tempestofset/faithinset.png"
import tempestofsetfangsofset from "assets/images/classes/tempestofset/fangsofset.png"
import tempestofsetforceoflightning from "assets/images/classes/tempestofset/forceoflightning.png"
import tempestofsetforkedlightning from "assets/images/classes/tempestofset/forkedlightning.png"
import tempestofsetglorificationofset from "assets/images/classes/tempestofset/glorificationofset.png"
import tempestofsetgrowingstorm from "assets/images/classes/tempestofset/growingstorm.png"
import tempestofsethealinglotus from "assets/images/classes/tempestofset/healinglotus.png"
import tempestofsetidolofdarkrejuvenation from "assets/images/classes/tempestofset/idolofdarkrejuvenation.png"
import tempestofsetidolofset from "assets/images/classes/tempestofset/idolofset.png"
import tempestofsetinnercharge from "assets/images/classes/tempestofset/innercharge.png"
import tempestofsetleviathanscall from "assets/images/classes/tempestofset/leviathanscall.png"
import tempestofsetlifeofset from "assets/images/classes/tempestofset/lifeofset.png"
import tempestofsetlightningarc from "assets/images/classes/tempestofset/lightningarc.png"
import tempestofsetlightningcast from "assets/images/classes/tempestofset/lightningcast.png"
import tempestofsetlightningsparks from "assets/images/classes/tempestofset/lightningsparks.png"
import tempestofsetlightningstormnimbus from "assets/images/classes/tempestofset/lightningstormnimbus.png"
import tempestofsetlightningstrikes from "assets/images/classes/tempestofset/lightningstrikes.png"
import tempestofsetlull from "assets/images/classes/tempestofset/lull.png"
import tempestofsetmarkofset from "assets/images/classes/tempestofset/markofset.png"
import tempestofsetovercharge from "assets/images/classes/tempestofset/overcharge.png"
import tempestofsetpoweroftheserpentring from "assets/images/classes/tempestofset/poweroftheserpentring.png"
import tempestofsetpuppetsofset from "assets/images/classes/tempestofset/puppetsofset.png"
import tempestofsetquicksand from "assets/images/classes/tempestofset/quicksand.png"
import tempestofsetrousingshock from "assets/images/classes/tempestofset/rousingshock.png"
import tempestofsetserpenttransmutation from "assets/images/classes/tempestofset/serpenttransmutation.png"
import tempestofsetsetslifespark from "assets/images/classes/tempestofset/setslifespark.png"
import tempestofsetslipfree from "assets/images/classes/tempestofset/slipfree.png"
import tempestofsetsparkoflife from "assets/images/classes/tempestofset/sparkoflife.png"
import tempestofsetsparkstorm from "assets/images/classes/tempestofset/sparkstorm.png"
import tempestofsetstaggeringvoice from "assets/images/classes/tempestofset/staggeringvoice.png"
import tempestofsetstaticblood from "assets/images/classes/tempestofset/staticblood.png"
import tempestofsetstormblood from "assets/images/classes/tempestofset/stormblood.png"
import tempestofsetstormcharge from "assets/images/classes/tempestofset/stormcharge.png"
import tempestofsetstormcrown from "assets/images/classes/tempestofset/stormcrown.png"
import tempestofsetstormfield from "assets/images/classes/tempestofset/stormfield.png"
import tempestofsetstormnimbus from "assets/images/classes/tempestofset/stormnimbus.png"
import tempestofsetstormregalia from "assets/images/classes/tempestofset/stormregalia.png"
import tempestofsetsummonauraofnebthu from "assets/images/classes/tempestofset/summonauraofnebthu.png"
import tempestofsetthunderingvoice from "assets/images/classes/tempestofset/thunderingvoice.png"
import tempestofsettriumphantlifeofset from "assets/images/classes/tempestofset/triumphantlifeofset.png"
import tempestofsetvitalizingjolt from "assets/images/classes/tempestofset/vitalizingjolt.png"
import tempestofsetvitalshock from "assets/images/classes/tempestofset/vitalshock.png"
import tempestofsetwrathoftheserpentring from "assets/images/classes/tempestofset/wrathoftheserpentring.png"
import { AocClasses } from "@pvplevelup/core/dist/interfaces/ICharacter";

const AbilityIcons: any = {
  "Fatality": Fatality,
  "Fear Immunity": FearImmunity,
  "Knockback immunity": KnockbackImmunity,
  "Recently Impaired": RecentlyImpaired,
  "Root Immunity": RootImmunity,
  "Silence Immunity": SilenceImmunity,
  "Snare Immunity": SnareImmunity,
  "Stun Immunity": StunImmunity,
  "Elemental Ruin": ElementalRuin,
  "Elemental Torment": ElementalTorment,
  "Elemental Wrack": ElementalWrack,
  "Physical Ruin": PhysicalRuin,
  "Physical Torment": PhysicalTorment,
  "Physical Wrack": PhysicalWrack,
  "Spiritual Ruin": SpiritualRuin,
  "Spiritual Torment": SpiritualTorment,
  "Spiritual Wrack": SpiritualWrack,
  "White Damage": WhiteDamage,
  "Slam": Slam,
  "Sweep": Sweep,
  "Cunning Strike I": Cunning1,
  "Cunning Strike II": Cunning2,
  "Cunning Strike III": Cunning3,
  "Cunning Strike IV": Cunning4,
  "Cunning Strike V": Cunning5,
  "Cunning VI": Cunning6,
  "Enraging Strike I": EnragingStrike1,
  "Enraging Strike II": EnragingStrike2,
  "Enraging Strike III": EnragingStrike3,
  "Enraging Wound I": EnragingWound1,
  "Brutal Enraging Strike I": BrutalEnragingStrike1,
  "Brutal Enraging Strike II": BrutalEnragingStrike2,
  "Brutal Enraging Strike III": BrutalEnragingStrike3,
  "BrutalEnragingWound1": BrutalEnragingWound1,
  "Vicious Strike I": ViciousStrike1,
  "Vicious Strike II": ViciousStrike2,
  "Ether Discharge": etherdischarge,
  "Saintly Martyr": saintlymartyr,
  "Saintly Warrior": saintlywarrior,
  "Shroud of the Gods": shroudofthegods,
  "Vengeance of the Gods": vengeanceofthegods,
  "Celestial Gaze":celestialgaze,
  "Agile Mind": agilemind,
  "Ambush": ambush,
  "Brutality": brutality,
  "Escape Artist": escapeartist,
  "Excellent Balance": excellentbalance,
  "Mountaineer": mountaineer,
  "Second Wind": secondwind,
  "Trickery": trickery,
  "Wiles": wiles,
  "Burning Vigor": burningvigor,
  "Cunning Defletction": cunningdefletction,
  "Defensive Stance": defensivestance,
  "Frenzy Stance": frenzystance,
  "Goad": goad,
  "Goad Mob": goadmob,
  "Hateful Strikes": hatefulstrikes,
  "Surging Health": surginghealth,
  "Volcanic Rage": volcanicrage,
  "Dark Meditation": darkmeditation,
  "Misdirection": misdirection,
  "Purge": purge,
  "Tome of Erlik": tomeoferlik,
  "Improved Fiery Weapons":heraldofxotlifireweapons,
  "Aura of Dread Fury":darktemplarauraofdreadfury,
  "Elemental Fury":tempestofsetelementalfury,
  "Storm Crown":tempestofsetstormcrown,
  "Call Lightning":tempestofsetcalllightning,
  "Aura of Nebthu":tempestofsetsummonauraofnebthu,
  "Idol of Set's Charge Stone":tempestofsetidolofset,
  "Idol of Set's Storm Field":tempestofsetidolofset,
  "Storm Charge":tempestofsetstormcharge,
  "Rebuke":priestofmitrarebuke,
  "Repulse":priestofmitrarepulse,
  "Desecrating Essence":heraldofxotlidesecratingessence,
  //assassin
  Assassin:{
    "Accelerated":assassinaccelerated,
    "Arcane Backlash":assassinarcanebacklash,
    "Atrophy":assassinatrophy,
    "Avatar of Death":assassinavatarofdeath,
    "Baneful Venom":assassinbanefulvenom,
    "Baneful Venom I":assassinbanefulvenom,
    "Baneful Venom II":assassinbanefulvenom,
    "Baneful Venom III":assassinbanefulvenom,
    "Baneful Venom IV":assassinbanefulvenom,
    "Baneful Venom V":assassinbanefulvenom,
    "Bewilder":assassinbewilder,
    "Blindside":assassinblindside,
    "Burden to Bear":assassinburdentobear,
    "Castration":assassincastration,
    "Cat's Paw":assassincatspaw,
    "Choking Powder":assassinchokingpowder,
    "Cover of Dusk":assassincoverofdusk,
    "Crimson Lotus Pollen":assassincrimsonlotuspollen,
    "Crippling Weakness":assassincripplingweakness,
    "Crystallized Lotus Extract":assassincrystallizedlotusextract,
    "Curse of the Lotus":assassincurseofthelotus,
    "Dance of Death":assassindanceofdeath,
    "Dark Weapons":assassindarkweapons,
    "Death's Gaze":assassindeathsgaze,
    "Death Whirlwind":assassindeathwhirlwind,
    "Disfigure":assassindisfigure,
    "Dread Venom":assassindreadvenom,
    "Dread Weapon":assassindreadweapon,
    "Dull Pain":assassindullpain,
    "Soul Toxin: Essence Detonation":assassinessencedetonation,
    "Facestab":assassinfacestab,
    "Flesh Rot":assassinfleshrot,
    "Flurry of Blows":assassinflurryofblows,
    "From the Darkness":assassinfromthedarkness,
    "Grave's Blossom":assassingravesblossom,
    "Grim Corruption I":assassingrimcorruption1,
    "Grim Corruption II":assassingrimcorruption2,
    "Grim Corruption III":assassingrimcorruption3,
    "Grim Corruption IV":assassingrimcorruption4,
    "Grim Corruption V":assassingrimcorruption5,
    "Impede Essence":assassinimpedeessence,
    "Impede Life":assassinimpedelife,
    "Impede Life II":assassinimpedelife2,
    "Kidney Shots":assassinkidneyshots,
    "Lethargy I":assassinlethargy1,
    "Lethargy II":assassinlethargy2,
    "Lethargy III":assassinlethargy3,
    "Miasma: Lotus-Coated Dart":assassinlotuscoateddart,
    "Miasma: Face Stab":assassinfacestab,
    "Lotus Overdose":assassinlotusoverdose,
    "Lotus Overload":assassinlotusoverload,
    "Lotus Toxin: Deadly Venom": assassinlotustoxindeadlyvenom,
    "Lotus Weapon":assassinlotusweapon,
    "Lotus Weapons":assassinlotusweapon,
    "Master Assassin":assassinmasterassassin,
    "Necrosis":assassinnecrosis,
    "Necrotic Empowerment":assassinnecroticempowerment,
    "Opportunistic Strike":assassinopportunisticstrike,
    "Poisoned Blades":assassinpoisonedblades,
    "Sins of the Flesh":assassinsinsoftheflesh,
    "Slow Death Strike I":assassinslowdeathstrike1,
    "Slow Death Strike II":assassinslowdeathstrike2,
    "Slow Death Strike III":assassinslowdeathstrike3,
    "Slow Death Strike IV":assassinslowdeathstrike4,
    "Slow Death Strike V":assassinslowdeathstrike5,
    "Snap Kick":assassinsnapkick,
    "Soul Corruption":assassinsoulcorruption,
    "Miasma: Soul Strike":assassinsoulstrike,
    "Spirit of Nightfall":assassinspiritofnightfall,
    "Swift Strikes I":assassinswiftstrikes1,
    "Swift Strikes II":assassinswiftstrikes2,
    "Swift Strikes III":assassinswiftstrikes3,
    "Swift Strikes IV":assassinswiftstrikes4,
    "Swift Strikes V":assassinswiftstrikes5,
    "Swift Strikes VI":assassinswiftstrikes6,
    "Swift Strikes VII":assassinswiftstrikes7,
    "Swift Strikes VIII":assassinswitfstrikes8,
    "Swift Strikes IX":assassinswiftstrikes9,
    "Swift Strikes X":assassinswiftstrikes10,
    "Vampyric Nature":assassinvampyricnature,
    "Vile Corruption":assassinvilecorruption,
  },
  //barbarian
  Barbarian:{
    "Arcane Marauder":barbarianarcanemarauder,
    "Armageddon Falls":barbarianarmageddonfalls,
    "At the Gates":barbarianatthegates,
    "Back in the Fray":barbarianbackinthefray,
    "Blitz":barbarianblitz,
    "Blood Frenzy":barbarianbloodfrenzy,
    "Blood Fury":barbarianbloodfury,
    "Blood Rage Stance":barbarianbloodragestance,
    "Bone Shatter":barbarianboneshatter,
    "Butcher I":barbarianbutcher1,
    "Butcher II":barbarianbutcher2,
    "Butcher III":barbarianbutcher3,
    "Butcher IV":barbarianbutcher4,
    "Butcher V":barbarianbutcher5,
    "Butcher VI":barbarianbutcher6,
    "Butcher VII":barbarianbutcher7,
    "Butcher VIII":barbarianbutcher8,
    "Butcher IX":barbarianbutcher9,
    "Butcher X":barbarianbutcher10,
    "Clobber I":barbarianclobber1,
    "Clobber II":barbarianclobber2,
    "Clobber III":barbarianclobber3,
    "Clobber IV":barbarianclobber4,
    "Clobber V":barbarianclobber5,
    "Concussion":barbarianconcussion,
    "Cyclone of Steel I":barbariancycloneofsteel1,
    "Cyclone of Steel II":barbariancycloneofsteel2,
    "Cyclone of Steel III":barbariancycloneofsteel3,
    "Cyclone of Steel IV":barbariancycloneofsteel4,
    "Cyclone of Steel V":barbariancycloneofsteel5,
    "Cyclone of Steel VI":barbariancycloneofsteel6,
    "Cyclone of Steel VII":barbariancycloneofsteel7,
    "Cyclone of Steel VIII":barbariancycloneofsteel8,
    "Cyclone of Steel IX":barbariancycloneofsteel9,
    "Cyclone of Steel X":barbariancycloneofsteel10,
    "Dance of Death":barbariandanceofdeath,
    "Decapitation":barbariandecapitation,
    "Determination":barbariandetermination,
    "Devastation":barbariandevastation,
    "Earth Shatter":barbarianearthshatter,
    "Eyes of Madness":barbarianeyesofmadness,
    "Finishing Blow":barbarianfinishingblow,
    "Haste":barbarianhaste,
    "Impale":barbarianimpale,
    "Jagged Cut I":barbarianjaggedcut1,
    "Jagged Cut II":barbarianjaggedcut2,
    "Jagged Cut III":barbarianjaggedcut3,
    "Jagged Cut IV":barbarianjaggedcut4,
    "No Escape":barbariannoescape,
    "Overpower":barbarianoverpower,
    "Paralysis":barbarianparalysis,
    "Predatory Instincts":barbarianpredatoryinstincts,
    "Rampaging Horde":barbarianrampaginghorde,
    "Reaver Stance":barbarianreaverstance,
    "Reverse Swing":barbarianreverseswing,
    "Rupture Armor":barbarianrupturearmor,
    "Savage Fury":barbariansavagefury,
    "Scatter Foes":barbarianscatterfoes,
    "Sever":barbariansever,
    "Shrapnel":barbarianshrapnel,
    "Staggering Blow I":barbarianstaggeringblow1,
    "Staggering Blow II":barbarianstaggeringblow2,
    "Staggering Blow III":barbarianstaggeringblow3,
    "Staggering Blow IV":barbarianstaggeringblow4,
    "Stunning Punch I":barbarianstunningpunch1,
    "Stunning Punch II":barbarianstunningpunch2,
    "Stunning Punch III":barbarianstunningpunch3,
    "Stunning Punch IV":barbarianstunningpunch4,
    "Stunning Punch V":barbarianstunningpunch5,
    "Swarm Fighter":barbarianswarmfighter,
    "Thirst for Blood":barbarianthirstforblood,
    "Tools at Hand":barbariantoolsathand,
    "Too Many to Count":barbariantoomanytocount,
    "Unstable Mind":barbarianunstablemind,
    "Upheaval":barbarianupheavel,
    "Welcoming Death":barbarianwelcomingdeath,
    "What it Takes":barbarianwhatittakes,
    "Whirlwind I":barbarianwhirlwind1,
    "Whirlwind II":barbarianwhirlwind2,
    "Whirlwind III":barbarianwhirlwind3,
    "Whirlwind IV":barbarianwhirlwind4,
    "Whirlwind V":barbarianwhirlwind5,
    "Without Warning":barbarianwithoutwarning,
    "Wreck Armor I":barbarianwreckarmor1,
    "Wreck Armor II":barbarianwreckarmor2,
    "Wreck Armor III":barbarianwreckarmor3,
    "Wreck Armor IV":barbarianwreckarmor4,
  },
  //bearshaman
  "Bear Shaman":{
    "Adrenaline Surge":bearshamanadrenalinesurge,
    "Arctic Slumber":bearshamanarcticslumber,
    "Awakening":bearshamanawakening,
    "Balance of Nature":bearshamanbalanceofnature,
    "Bewilder":bearshamanbewilder,
    "Blood Flow":bearshamanbloodflow,
    "Blood Thirst":bearshamanbloodthirst,
    "Bloodthirst":bearshamanbloodthirst,
    "Blood Warrior":bearshamanbloodwarrior,
    "Booming Roar":bearshamanboomingroar,
    "Censuring Strike I":bearshamancensuringstrike1,
    "Censuring Strike II":bearshamancensuringstrike2,
    "Censuring Strike III":bearshamancensuringstrike3,
    "Claws of Corruption":bearshamanclawsofcorruption,
    "Claws of Life":bearshamanclawsoflife,
    "Claws of Stone":bearshamanclawsofstone,
    "Claws of the Reaper":bearshamanclawsofthereaper,
    "Companion Spirit": bearshamanboomingroar,
    "Crush Armor I":bearshamancrusharmor1,
    "Crush Armor II":bearshamancrusharmor2,
    "Crush Armor III":bearshamancrusharmor3,
    "Crush Armor IV":bearshamancrusharmor4,
    "Desert Bloom":bearshamanmanifestationofthesun,
    "Ether Theft":bearshamanethertheft,
    "Feral Growl":bearshamanferalgrowl,
    "Ferocious Smack I":bearshamanferocioussmack,
    "Ferocious Smack II":bearshamanferocioussmack2,
    "Ferocious Smack III":bearshamanferocioussmack3,
    "Ferocious Smack IV":bearshamanferocioussmack4,
    "Ferocious Smack V":bearshamanferocioussmack5,
    "Fierce Recovery":bearshamanfiercerecovery,
    "Grace of Nature":bearshamangraceofnature,
    "Hinder Movement I":bearshamanhindermovement1,
    "Hinder Movement II":bearshamanhindermovement2,
    "Internal Bleed I":bearshamaninternalbleed1,
    "Internal Bleed II":bearshamaninternalbleed2,
    "Internal Bleed III":bearshamaninternalbleed3,
    "Internal Bleed IV":bearshamaninternalbleed4,
    "Iron Hide":bearshamanironhide,
    "Life Tap":bearshamanlifetap,
    "Lycanthropic Bite":bearshamanlycanthropicbite,
    "Circling Wolves":bearshamanlycanthropicbite,
    "Manifestation of Regrowth":bearshamanmanifestationofregrowth,
    "Manifestation of Spirit":bearshamanmanifestationofspirit,
    "Manifestation of the Forest":bearshamanmanifestationoftheforest,
    "Manifestation of the Sun":bearshamanmanifestationofthesun,
    "Manifestation of Winter":bearshamanmanifestationofwinter,
    "Maul":bearshamanmaul,
    "Nature's revenge":bearshamannaturesrevenge,
    "Nature's wrath":bearshamannatureswrath,
    "Poisoned Hide":bearshamanposionedhide,
    "Poisonous Rot":bearshamanposionedhide,
    "Rampage":bearshamanrampage,
    "Renewal":bearshamanrenewal,
    "Rune of Aggression":bearshamanruneofaggression,
    "Rune of Grounding":bearshamanruneofgrounding,
    "Rune of Resilience":bearshamanruneofresilience,
    "Rune of Resistance":bearshamanruneofresistance,
    "Scarred Hide":bearshamanscarredhide,
    "Shrewd Blow I":bearshamanshrewdblow1,
    "Shrewd Blow II":bearshamanshrewdblow2,
    "Shrewd Blow III":bearshamanshrewdblow3,
    "Shrewd Blow IV":bearshamanshrewdblow4,
    "Shrewd Blow V":bearshamanshrewdblow5,
    "Shrewd Blow VI":bearshamanshrewdblow6,
    "Sleuth of Bears":bearshamansleuthofbears,
    "Spirit of the Bear":bearshamanspiritofthebear,
    "Spirit of Yggdrasil":bearshamanspiritofyggdrasil,
    "Stone Hide":bearshamanstonehide,
    "Surge of Bile":bearshamansurgeofbile,
    "Ursine Bond":bearshamanursinebond,
    "Ursine Brawl I":bearshamanursinebrawl1,
    "Ursine Brawl II":bearshamanursinebrawl2,
    "Ursine Brawl III":bearshamanursinebrawl3,
    "Ursine Brawl IV":bearshamanursinebrawl4,
    "Ursine Crush":bearshamanursinecrush,
    "Ursine Rush":bearshamanursinerush,
    "Vision of the Sky":bearshamanvisionofthesky,
    "Winter's Bite":bearshamanwintersbite,
    "World Walker": bearshamanmanifestationofspirit
  },
  //conqueror
  Conqueror:{
    "Annihilate":conquerorannihilate,
    "Art of War":conquerorartofwar,
    "Assail":conquerorassail,
    "At Death's Door":conqueroratdeathsdoor,
    "Batter Aside I":conquerorbatteraside1,
    "Batter Aside II":conquerorbatteraside2,
    "Batter Aside III":conquerorbatteraside3,
    "Batter Aside IV":conquerorbatteraside4,
    "Batter Aside V":conquerorbatteraside5,
    "Battlefield Commander":conquerorbattlefieldcommander,
    "Berserk Inspiration":conquerorberserkinspiration,
    "Besiege":conquerorbesiege,
    "Bladeweave":conquerorbladeweave,
    "Blessed Blade":conquerorblessedblade,
    "Blessed Conquest":conquerorblessedconquest,
    "Bloodbath I":conquerorbloodbath1,
    "Bloodbath II":conquerorbloodbath2,
    "Bloodbath III":conquerorbloodbath3,
    "Bloodbath IV":conquerorbloodbath4,
    "Bloodbath V":conquerorbloodbath5,
    "Bloodbath VI":conquerorbloodbath6,
    "Bloodbath VII":conquerorbloodbath7,
    "Blood Lust":conquerorbloodlust,
    "Bloody Hack I":conquerorbloodyhack1,
    "Bloody Hack II":conquerorbloodyhack2,
    "Bloody Hack III":conquerorbloodyhack3,
    "Bloody Hack IV":conquerorbloodyhack4,
    "Bloody Hack V":conquerorbloodyhack5,
    "Bloody Hack VI":conquerorbloodyhack6,
    "Breach I":conquerorbreach1,
    "Breach II":conquerorbreach2,
    "Breach III":conquerorbreach3,
    "Breach IV":conquerorbreach4,
    "Break Through":conquerorbreakthrough,
    "Burst of Aggression":conquerorburstofaggression,
    "Crippling Laceration":conquerorcripplinglaceration,
    "Crushing Onslaught":conquerorcrushingonslaught,
    "Cunning":conquerorcunning,
    "Deep Wounds":conquerordeepwounds,
    "Defiance":conquerordefiance,
    "Discipline Will of Mettle":conquerordisciplinewillofmettle,
    "Discipline Will of Onslaught":conquerordisciplinewillofonslaught,
    "Discipline Will of Vivification":conquerordisciplinewillofvivification,
    "Feint Attack I":conquerorfeintattack1,
    "Feint Attack II":conquerorfeintattack2,
    "Feint Attack III":conquerorfeintattack3,
    "Feint Attack IV":conquerorfeintattack4,
    "Feint Attack V":conquerorfeintattack5,
    "Feint Attack VI":conquerorfeintattack6,
    "Feint Attack VII":conquerorfeintattack7,
    "Feint Attack VIII":conquerorfeintattack8,
    "Feint Attack IX":conquerorfeintattack9,
    "Flashing Defense":conquerorflashingdefense,
    "Formation: The Burning Standard":conquerorformationtheburningstandard,
    "Formation: The Fortifying Standard":conquerorformationthefortifyingstandard,
    "Formation: The Restoring Standard":conquerorformationtherestoringstandard,
    "Furious Inspiration":conquerorfuriousinspiration,
    "Furious Resurgence":conquerorfuriousresurgence,
    "Furious Strikes":conquerorfuriousstrikes,
    "Granttechnique":conquerorgranttechnique,
    "Guard of Dancing Steel I":conquerorguardofdancingsteel1,
    "Guard of Dancing Steel II":conquerorguardofdancingsteel2,
    "Guard of Dancing Steel III":conquerorguardofdancingsteel3,
    "Guard of Dancing Steel IV":conquerorguardofdancingsteel4,
    "Hail of Furious Strikes I":conquerorhailoffuriousstrikes1,
    "Hail of Furious Strikes II":conquerorhailoffuriousstrikes2,
    "Hail of Furious Strikes III":conquerorhailoffuriousstrikes3,
    "Hail of Furious Strikes IV":conquerorhailoffuriousstrikes4,
    "Hail of Furious Strikes V":conquerorhailoffuriousstrikes5,
    "Hail of Furious Strikes VI":conquerorhailoffuriousstrikes6,
    "Heroic Call":conquerorheroiccall,
    "Improved Rend":conquerorrendflesh,
    "Lacerate":conquerorlacerate,
    "Lightning Steel":conquerorlightningsteel,
    "Lumbering Hulk":conquerorlumberinghulk,
    "One Last Push":conqueroronelastpush,
    "Overcome the Odds":conquerorovercometheodds,
    "Overwhelm I":conqueroroverwhelm1,
    "Overwhelm II":conqueroroverwhelm2,
    "Overwhelm III":conqueroroverwhelm3,
    "Overwhelm IV":conqueroroverwhelm4,
    "Overwhelm V":conqueroroverwhelm5,
    "Overwhelm VI":conqueroroverwhelm6,
    "Plant Banner":conquerorplantbanner,
    "Rally":conquerorrally,
    "Rend Flesh":conquerorrendflesh,
    "Resurgence":conquerorresurgence,
    "Retaliation":conquerorretaliation,
    "Ruthless Assault":conquerorruthlessassault,
    "The Burning Standard":conquerorformationtheburningstandard,
    "The Burning Standard's The Burning Standard":conquerorformationtheburningstandard,
    "Throat Slash":conquerorthroatslash,
    "War Lord":conquerorwarlord,
    "Whirlwind":conquerorwhirlwind,
  },
  //darktemplar
  "Dark Templar":{
    "Air of Death":darktemplarairofdeath,
    "Approach of Death":darktemplarcovenantofarms,
    "A Soul for our Feast I":darktemplarasoulforourfeast1,
    "A Soul for our Feast II":darktemplarasoulforourfeast2,
    "A Soul for our Feast III":darktemplarasoulforourfeast3,
    "A Soul for our Feast IV":darktemplarasoulforourfeast4,
    "A Soul for our Feast V":darktemplarasoulforourfeast5,
    "Aura of Infusion":darktemplarauraofinfusion,
    "Aura of Dread Fury":darktemplarauraofdreadfury,
    "Blighted Soul":darktemplarblightedsoul,
    "Blighted Touch":darktemplarblightedtouch,
    "Blood for Aid I":darktemplarbloodforaid1,
    "Blood for Aid II":darktemplarbloodforaid2,
    "Blood for Aid III":darktemplarbloodforaid3,
    "Blood for Aid IV":darktemplarbloodforaid4,
    "Blood for Aid V":darktemplarbloodforaid5,
    "Bloodforblood":darktemplarbloodforblood,
    "Bloodhex":darktemplarbloodhex,
    "Blood Hex":darktemplarbloodhex,
    "Blood Pact":darktemplarbloodpact,
    "Blood Shroud":darktemplarbloodshroud,
    "Consuming Bulwark":darktemplarconsumingbulwark,
    "Corruption":darktemplarcorruption,
    "Covenant of Arms":darktemplarcovenantofarms,
    "Covenant of Invulnerability":darktemplarcovenantofinvulnerability,
    "Covenant of Pestilence":darktemplarcovenantofpestilence,
    "Covenant of Vengeance":darktemplarcovenantofvengeance,
    "Covenants of Death":darktemplarcovenantsofdeath,
    "Crimson Succor":darktemplarcrimsonsuccor,
    "Crystallized Chaos":darktemplarcrystallizedchaos,
    "Curse of Gwahlur":darktemplarcurseofgwahlur,
    "Dark Burden":darktemplardarkburden,
    "Death Lord":darktemplardeathlord,
    "Dooming Presence":darktemplardoomingpresence,
    "Drain Essence":darktemplardrainessence,
    "Drain Life":darktemplardrainlife,
    "Dread Shadow":darktemplardreadshadow,
    "Dread Shadow's Aura of Dread Fury":darktemplarauraofdreadfury,
    "Ether Reap":darktemplaretherreap,
    "Hex Marked Soul":darktemplarhexmarkedsoul,
    "Invulnerable Soul":darktemplarinvulnerablesoul,
    "Leech Life I":darktemplarlifeleech1,
    "Leech Life II":darktemplarlifeleech2,
    "Leech Life III":darktemplarlifeleech3,
    "Leech Life IV":darktemplarlifeleech4,
    "Leech Life V":darktemplarlifeleech5,
    "Leech Life VI":darktemplarlifeleech6,
    "Malacodor's Blight": darktemplarpactofmalacodor,
    "Martyrdom":darktemplarmartyrdom,
    "Mind Shatter":darktemplarmindshatter,
    "Mind Wrack":darktemplarmindwrack,
    "Mystical Bane I":darktemplarmysticalbane1,
    "Mystical Bane II":darktemplarmysticalbane2,
    "Mystical Bane III":darktemplarmysticalbane3,
    "Mystical Bane IV":darktemplarmysticalbane4,
    "Mystical Bane V":darktemplarmysticalbane5,
    "Pact of Malacodor":darktemplarpactofmalacodor,
    "Rite of Blood":darktemplarriteofblood,
    "Ritualistic Bloodshed":darktemplarritualisticbloodshed,
    "Sadistic Soul":darktemplarsadisticsoul,
    "Sanguine Infusion":darktemplarsanguineinfusion,
    "Scarab Knight":darktemplarscarabknight,
    "Seal of Chaos":darktemplarsealofchaos,
    "Seal of Yog":darktemplarsealofyog,
    "Shadowed Soul":darktemplarshadowedsoul,
    "Shadow Hex":darktemplarshadowhex,
    "Soul Barrier":darktemplarsoulbarrier,
    "Talisman Mastery":darktemplartalismanmastery,
    "Touch of Death":darktemplartouchofdeath,
    "Unhallowed Blight I":darktemplarunhallowedblight1,
    "Unhallowed Blight II":darktemplarunhallowedblight2,
    "Unhallowed Blight III":darktemplarunhallowedblight3,
    "Unhallowed Blight IV":darktemplarunhallowedblight4,
    "Unwilling Sacrifice":darktemplarunwillingsacrifice,
    "Void of Madness":darktemplarvoidofmadness,
    "Zone of Gluttony": darktemplarzoneofgluttony
  },
  //demonologist
  Demonologist:{
    "Abaddoron Warrior":demonologistabaddoronwarrior,
    "Abyssal Flameweaver's Flameweave": demonologistamassedflames,
    "Agonizing Jolts":demonologistagonizingjolts,
    "Amassed Flames":demonologistamassedflames,
    "Archfiend's Pact":demonologistarchfiendspact,
    "Bindings of the Skylord":demonologistbindingsoftheskylord,
    "Blistering Wounds":demonologistblisteringwounds,
    "Bloody Pact with Set":demonologistbloodypactwithset,
    "Boil Blood":demonologistboilblood,
    "Break Pact":demonologistbreakpact,
    "Cacodemon":demonologistcacodemon,
    "Cacodemon's Infernal Blast":demonologistcacodemon,
    "Chaotic Blast":demonologistchaoticblast,
    "Charged Storm Chains":demonologistchargedstormchains,
    "Circle of Magic":demonologistcircleofmagic,
    "Consume Heart":demonologistconsumeheart,
    "Consuming Flames":demonologistconsumingflames,
    "Cursed by Heavens":demonologistcursedbyheavens,
    "Cursed by Hell":demonologistcursedbyhell,
    "Demon Avenger":demonologistdemonavenger,
    "Demon Avenger's Dreadlight":demonologistdemonavenger,
    "Demon Familiar":demonologistdemonfamiliar,
    "Demon Familiar's Infernal Seed":demonologistdemonfamiliar,
    "Demon Guardian":demonologistdemonguardian,
    "Demon Guardian's Soulwrench":demonologistdemonguardian,
    "Demonic Heart":demonologistdemonicheart,
    "Demonic Renewal":demonologistdemonicrenewal,
    "Demonic War":demonologistdemonicwar,
    "Demon Slave":demonologistdemonslave,
    "Demon Slave's Infernal Combustion":demonologistdemonslave,
    "Demon Warlord":demonologistdemonwarlord,
    "Demon Warlord's Infernal Flames":demonologistdemonwarlord,
    "Detonation":demonologistdetonation,
    "Devouring Flames":demonologistdevouringflames,
    "Draw Forth the Heart":demonologistdrawforththeheart,
    "Earth Recharge":demonologistearthrecharge,
    "Fiery Torment":demonologistfierytorment,
    "Fires of Gehenna":demonologistfiresofgehenna,
    "Gate of Hell":demonologistgateofhell,
    "Greater Flames":demonologistgreaterflames,
    "Hand of Doom":demonologisthandofdoom,
    "Hands of the Underworld":demonologisthandsoftheunderworld,
    "Hellfire Stream":demonologisthellfirestream,
    "Hell's Garden":demonologisthellsgarden,
    "Impish Horde":demonologistimpishhorde,
    "Incinerate":demonologistincinerate,
    "Inferno of Amher":demonologistinfernoofamher,
    "Intense Heat": demonologistintenseheat,
    "Let Them Burn":demonologistletthemburn,
    "Living Firestorm":demonologistlivingfirestorm,
    "Living Firestorm's Firestorm":demonologistlivingfirestorm,
    "Living Thunderstorm":demonologistlivingthunderstorm,
    "Living Thunderstorm's Thunderstorm":demonologistlivingthunderstorm,
    "Lore of Skelos":demonologistloreofskelos,
    "Mystic Suppression":demonologistmysticsuppression,
    "Overload":demonologistoverload,
    "Pact of Dread":demonologistpactofdread,
    "Pact with Set":demonologistpactwithset,
    "Planar Shift":demonologistplanarshift,
    "Possession":demonologistpossession,
    "Protection of Set":demonologistprotectionofset,
    "Renegotiation":demonologistrenegotiation,
    "Ring of Fire":demonologistringoffire,
    "Ruinous Power":demonologistruinouspower,
    "Sacrificial Heart":demonologistsacrificialheart,
    "Shield of Infernal Flames":demonologistshieldofinfernalflames,
    "Shock":demonologistshock,
    "Shockblast":demonologistshockblast,
    "Shock Lance":demonologistshocklance,
    "Shockstrike":demonologistshockstrike,
    "Soul Resonance":demonologistsoulresonance,
    "Storm Chains":demonologiststormchains,
    "Subtle Illusion":demonologistsubtleillusion,
    "Thunder Clap":demonologistthunderclap,
    "Unleash the Underworld":demonologistunleashtheunderworld,
    "Waves of Flame":demonologistwavesofflame,
    "Wicked Bolt":demonologistwickedbolt,
  },
  //guardian
  Guardian:{
    "Battle Cry":guardianbattlecry,
    "Bloody Vengeance":guardianbloodyvengeance,
    "Call to Arms":guardiancalltoarms,
    "Champion Spirit":guardianchampionspirit,
    "Counterstrike I":guardiancounterstrike1,
    "Counterstrike II":guardiancounterstike2,
    "Counterstrike III":guardiancounterstrike3,
    "Counterstrike IV":guardiancounterstrike4,
    "Counterweight":guardiancounterweight,
    "Cry of Havoc":guardiancryofhavoc,
    "Deliberate Reprisal":guardiandeliberatereprisal,
    "Disable I":guardiandisable1,
    "Disable II":guardiandisable2,
    "Disable III":guardiandisable3,
    "Disable IV":guardiandisable4,
    "Disarming Aggression":guardiandisarmingaggression,
    "Dulling Blow I":guardiandullingblow1,
    "Dulling Blow II":guardiandullingblow2,
    "Dulling Blow III":guardiandullingblow3,
    "Dulling Blow IV":guardiandullingblow4,
    "Dulling Blow V":guardiandullingblow5,
    "Flashing Arc I":guardianflashingarc1,
    "Flashing Arc II":guardianflashingarc2,
    "Flashing Arc III":guardianflashingarc3,
    "Flashing Arc IV":guardianflashingarc4,
    "Flashing Arc V":guardianflashingarc5,
    "Flashing Arc VI":guardianflashingarc6,
    "Flashing Arc VII":guardianflashingarc7,
    "Flashing Arc VIII":guardianflashingarc8,
    "Flashing Arc IX":guardianflashingarc9,
    "Guard I":guardianguard1,
    "Guard II":guardianguard2,
    "Guard III":guardianguard3,
    "Guard IV":guardianguard4,
    "Guard V":guardianguard5,
    "Guard Destroyer I":guardianguarddestroyer1,
    "Guard Destroyer II":guardianguarddestroyer2,
    "Guard Destroyer III":guardianguarddestroyer3,
    "Guard Destroyer IV":guardianguarddestroyer4,
    "Impale":guardianimpale,
    "Intimidating Shout":guardianintimidatingshout,
    "Juggernaut":guardianjuggernaut,
    "Lightning Reflexes":guardianlightningreflexes,
    "Maneuver: Elusive Daring":guardianmaneuverelusivedaring,
    "Maneuver: Mental Barrier":guardianmaneuvermentalbarrier,
    "Maneuver: Wall of Steel":guardianmaneuverwallofsteel,
    "Master at Arms":guardianmasteratarms,
    "Morale Boost":guardianmoraleboost,
    "Overreach I":guardianoverreach1,
    "Overreach II":guardianoverreach2,
    "Overreach III":guardianoverreach3,
    "Overreach IV":guardianoverreach4,
    "Overreach V":guardianoverreach5,
    "Overreach VI":guardianoverreach6,
    "Overwhelming Shout":guardianoverwhelmingshout,
    "Plexus Strike I":guardianplexusstrike1,
    "Plexus Strike II":guardianplexusstrike2,
    "Plexus Strike III":guardianplexusstrike3,
    "Powerhouse":guardianpowerhouse,
    "Prime Initiative":guardianprimeinitiative,
    "Reckoning":guardianreckoning,
    "Redoubt":guardianredoubt,
    "Riposte":guardianriposte,
    "Shield Slam": guardianshieldslam,
    "Shield Strike": guardianshieldstrike,
    "Shield Sweep I":guardianshieldsweep1,
    "Shield Sweep II":guardianshieldsweep2,
    "Shield Sweep III":guardianshieldsweep3,
    "Shield Sweep IV":guardianshieldsweep4,
    "Shield Sweep V":guardianshieldsweep5,
    "Skewer":guardianskewer,
    "Stagger I":guardianstagger1,
    "Stagger II":guardianstagger2,
    "Stagger III":guardianstagger3,
    "Stagger IV":guardianstagger4,
    "Stagger V":guardianstagger5,
    "Stall the Advance":guardianstalltheadvance,
    "Stand your Ground":guardianstandyourground,
    "Storm Blade": guardianstormblade,
    "Storm Strike":guardianstormstrike,
    "Strike and Guard":guardianstrikeandguard,
    "Stunning Charge":guardianstunningcharge,
    "Subterfuge":guardiansubterfuge,
    "Sustaining Wrath":guardiansustainingwrath,
    "Tactic: Attack":guardiantacticattack,
    "Tactic: Defense":guardiantacticdefense,
    "Tactic: Provoke":guardiantacticprovoke,
    "The Last Stand":guardianthelaststand,
    "Titanic Smash":guardiantitanicsmash,
    "Vengeance is Mine":guardianvengeanceismine,
  },
  //heraldofxotli
  "Herald of Xotli":{
    "Arcane Abatement":heraldofxotliarcaneabatement,
    "Avatar of Xotli":heraldofxotliavatarofxotli,
    "Body and Spirit Wrack I":heraldofxotlibodyandspiritwrack1,
    "Body and Spirit Wrack II":heraldofxotlibodyandspiritwrack2,
    "Body and Spirit Wrack III":heraldofxotlibodyandspiritwrack3,
    "Body and Spirit Wrack IV":heraldofxotlibodyandspiritwrack4,
    "Burning Hex":heraldofxotliburninghex,
    "Burning Skull":heraldofxotliburningskull,
    "Burn to Death I":heraldofxotliburntodeath1,
    "Burn to Death II":heraldofxotliburntodeath2,
    "Burn to Death III":heraldofxotliburntodeath3,
    "Burn to Death IV":heraldofxotliburntodeath4,
    "Burn to Death V":heraldofxotliburntodeath5,
    "Burn to Death VI":heraldofxotliburntodeath6,
    "Chains of Anguish":heraldofxotlichainsofanguish,
    "Contract of Protection":heraldofxotlicontractofprotection,
    "Demon Maw":heraldofxotlidemonmaw,
    "Desecrating Essence":heraldofxotlidesecratingessence,
    "Dread Visage":heraldofxotlidreadvisage,
    "Enslaving Fire":heraldofxotlienslavingfire,
    "Exultation of Xotli":heraldofxotliexultationofxotli,
    "Ether Thirst":heraldofxotlietherthirst,
    "Feeding the Pyre":heraldofxotlifeedingthepyre,
    "Fire Lance":heraldofxotlifirelance,
    "Fire Weapons":heraldofxotlifireweapons,
    "Fiery Weapons":heraldofxotlifireweapons,
    "Flame Lash":heraldofxotliflamelash,
    "Flame Tongue":heraldofxotliflametongue,
    "From the Beyond":heraldofxotlifromthebeyond,
    "Fury of Xotli":heraldofxotlifuryofxotli,
    "Hellfire Breath":heraldofxotlihellfirebreath,
    "Hell on Earth":heraldofxotlihellonearth,
    "Hellsteps":heraldofxotlihellsteps,
    "Hellstep":heraldofxotlihellsteps,
    "Hell Strikes I":heraldofxotlihellstrikes1,
    "Hell Strikes II":heraldofxotlihellstrikes2,
    "Hell Strikes III":heraldofxotlihellstrikes3,
    "Hell Strikes IV":heraldofxotlihellstrikes4,
    "Hell Strikes V":heraldofxotlihellstrikes5,
    "Hell Strikes VI":heraldofxotlihellstrikes6,
    "Hunger for More":heraldofxotlihungerformore,
    "I Eat Your Heart":heraldofxotliieatyourheart,
    "Improved Burning Skull": heraldofxotliburningskull,
    "Inferno":heraldofxotliinferno,
    "Inferno Curse":heraldofxotliinfernocurse,
    "Insanity of Xotli":heraldofxotliinsanityofxotli,
    "Molten Flesh":heraldofxotlimoltenflesh,
    "Molten Steel Slash I":heraldofxotlimoltensteelslash1,
    "Molten Steel Slash II":heraldofxotlimoltensteelslash2,
    "Molten Steel Slash III":heraldofxotlimoltensteelslash3,
    "Molten Steel Slash IV":heraldofxotlimoltensteelslash4,
    "Molten Steel Slash V":heraldofxotlimoltensteelslash5,
    "Molten Steel Slash VI":heraldofxotlimoltensteelslash6,
    "Phoenix Cloak":heraldofxotliphoenixcloak,
    "Pillar of Infernal Flame I":heraldofxotlipillarofinfernalflame1,
    "Pillar of Infernal Flame II":heraldofxotlipillarofinfernalflame2,
    "Pillar of Infernal Flame III":heraldofxotlipillarofinfernalflame3,
    "Prince of Terror":heraldofxotliprinceofterror,
    "Quickening Death":heraldofxotliquickeningdeath,
    "Red shadows of Xotli":heraldofxotliredshadowsofxotli,
    "Searing Curse":heraldofxotlisearingcurse,
    "Searing Hatred":heraldofxotlisearinghatred,
    "Spitfire":heraldofxotlispitfire,
    "Spreading Flames":heraldofxotlispreadingflames,
    "Thundering Flames":heraldofxotlithunderingflames,
    "Tongue of Xotli":heraldofxotlitongueofxotli,
    "Undying Glory of Xotli":heraldofxotliundyinggloryofxotli,
    "Word of Command":heraldofxotliwordofcommand,
  },
  //necromancer
  Necromancer:{
    "Ancient Soul":necromancerancientsoul,
    "Arcanist's Chill of the Grave": necromancerdeathlessacolytearcanist,
    "Arcanist's Cabal": necromancerdeathlessacolytearcanist,
    "Archmagus's Glacial Tomb": necromancerdreadarchmagearchmagus,
    "Archmagus's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Archmagus's Storm Charge": tempestofsetstormcharge,
    "Archmagus's Resonance": tempestofsetidolofset,
    "Blasphemed Flesh":necromancerblasphemedflesh,
    "Blasphemous Ruin":necromancerblasphemousruin,
    "Blasphemy":necromancerblasphemy,
    "Blighted One": necromancerundeadminionblightedone,
    "Blighted One's Bone Horde": necromancerbonehorde,
    "Blighted One's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Blighted One's Storm Charge": tempestofsetstormcharge,
    "Blighted One's Resonance": tempestofsetidolofset,
    "Blood Arcanist's Curse of Blood":necromancerdreadarchmagebloodarcanist,
    "Blood Arcanist's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Blood Arcanist's Storm Charge": tempestofsetstormcharge,
    "Blood Arcanist's Resonance": tempestofsetidolofset,
    "Bone Horde":necromancerbonehorde,
    "Cannibalism":necromancercannibalism,
    "Chill":necromancerchill,
    "Chilling Breath":necromancerchillingbreath,
    "Corruptor": necromancerundeadminioncorruptor,
    "Corruptor's Bone Horde": necromancerbonehorde,
    "Corruptor's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Corruptor's Storm Charge": tempestofsetstormcharge,
    "Corruptor's Resonance": tempestofsetidolofset,
    "Curse of Pain":necromancercurseofpain,
    "Death Eater":necromancerdeatheater,
    "Death God":necromancerdeathgod,
    "Deathless Acolyte: Arcanist":necromancerdeathlessacolytearcanist,
    "Deathless Acolyte: Magus":necromancerdeathlessacolytemagus,
    "Deathless Acolyte: Reaper":necromancerdeathlessacolytereaper,
    "Deathly Blizzard":necromancerdeathlyblizzard,
    "Death's Channel":necromancerdeathschannel,
    "Death's Terror":necromancerdeathsterror,
    "Decay":necromancerdecay,
    "Decays of Nature":necromancerdecaysofnature,
    "Despoil the Soul":necromancerdespoilthesoul,
    "Draw Forth the Heart":necromancerdrawforththeheart,
    "Dread Archmage: Archmagus":necromancerdreadarchmagearchmagus,
    "Dread Archmage: Blood Arcanist":necromancerdreadarchmagebloodarcanist,
    "Dread Blight":necromancerdreadblight,
    "Embrace Death":necromancerembracedeath,
    "Flesh of the Wight":necromancerfleshofthewight,
    "Flesh to Worms":necromancerfleshtoworms,
    "Freeze":necromancerfreeze,
    "Frenzy":necromancerfrenzy,
    "Frost Blast":necromancerfrostblast,
    "Frozen Hatred":necromancerfrozenhatred,
    "Frozen Hatred's Chill":necromancerfrozenhatred,
    "Frozen Hatred's Bone Horde":necromancerbonehorde,
    "Frozen Hatred's Storm Charge": tempestofsetstormcharge,
    "Frozen Hatred's Resonance": tempestofsetidolofset,
    "Funeral Rites":necromancerfuneralrites,
    "Gangrenous Stench":necromancergangrenousstench,
    "Gelid Bones":necromancergelidbones,
    "General of the Dead":necromancergeneralofthedead,
    "Ghoulish Feast":necromancerghoulishfeast,
    "Grim Corruptor":necromancergrimcorruptor,
    "Grim Hunger":necromancergrimhunger,
    "Grip of Death":necromancergripofdeath,
    "Harvest Soul":necromancerharvestsoul,
    "Harvester":necromancerundeadminionharvester,
    "Harvester's Bone Horde":necromancerbonehorde,
    "Harvester's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Harvester's Storm Charge": tempestofsetstormcharge,
    "Harvester's Resonance": tempestofsetidolofset,
    "Ice Shackle":necromancericeshackle,
    "Ice Strike":necromancericestrike,
    "Infestation":necromancerinfestation,
    "Life-stealer": necromancerundeadminionlifestealer,
    "Life-stealer's Bone Horde": necromancerbonehorde,
    "Life-stealer's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Life-stealer's Storm Charge": tempestofsetstormcharge,
    "Life-stealer's Resonance": tempestofsetidolofset,
    "Life Leech":necromancerlifeleech,
    "Lifestrike":necromancerlifestrike,
    "Magus's Crypt Blast": necromancerdeathlessacolytemagus,
    "Magus's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Magus's Storm Charge": tempestofsetstormcharge,
    "Magus's Resonance": tempestofsetidolofset,
    "Mark of the Devourer":necromancermarkofthedevourer,
    "Mutilator":necromancerundeadminionmutilator,
    "Mutilator's Bone Horde":necromancerbonehorde,
    "Mutilator's Mutilation":necromancerundeadminionmutilator,
    "Mutilator's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Mutilator's Storm Charge": tempestofsetstormcharge,
    "Mutilator's Resonance": tempestofsetidolofset,
    "Necrotic Bomb": necromancerundeadminionnecroticbomb,
    "Necrotic Bomb's Bone Horde": necromancerbonehorde,
    "Necrotic Bomb's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Necrotic Bomb's Storm Charge": tempestofsetstormcharge,
    "Necrotic Bomb's Resonance": tempestofsetidolofset,
    "Necrotic Detonation":necromancernecroticdetonation,
    "Necrotic Explosion":necromancernecroticdetonation,
    "Necrotic Pustule":necromancernecroticpustule,
    "Nether World Deception":necromancernetherworlddeception,
    "Nightmare Companions":necromancernightmarecompanions,
    "No Rest for the Dead":necromancernorestforthedead,
    "One with Death":necromanceronewithdeath,
    "Parasitic Soul": necromancerancientsoul,
    "Parasitic Soul's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Parasitic Soul's Storm Charge": tempestofsetstormcharge,
    "Parasitic Soul's Resonance": tempestofsetidolofset,
    "Parasitic Soul Swarm":necromancerparasiticsoulswarm,
    "Pestilential Blast":necromancerpestilentialblasr,
    "Plagued Heart Curse":necromancerplaguedheartcurse,
    "Plague Swarm":necromancerplagueswarm,
    "Presence of the Lich":necromancerritualofthelich,
    "Quell the Ether":necromancerquelltheether,
    "Reap the Soul":necromancerreapthesoul,
    "Reaper's Scourge": necromancerdeathlessacolytereaper,
    "Reaper's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Reaper's Storm Charge": tempestofsetstormcharge,
    "Reaper's Resonance": tempestofsetidolofset,
    "Ritual of the Lich":necromancerritualofthelich,
    "Ruined Blight":necromancerruinedblight,
    "Runed Flesh":necromancerrunedflesh,
    "Sacrifice":necromancersacrifice,
    "Scythe Shield":necromancerscytheshield,
    "Set's Cold Hatred":necromancersetscoldhatred,
    "Set's Ruin":necromancersetsruin,
    "Shatter":necromancershatter,
    "Siphon Unlife":necromancersiphonunlife,
    "Slaughter Wraith":necromancerundeadchampionslaughterwraith,
    "Slaughter Wraith's Bone Horde": necromancerbonehorde,
    "Slaughter Wraith's Aura of Dread Fury": darktemplarauraofdreadfury,
    "Slaughter Wraith's Storm Charge": tempestofsetstormcharge,
    "Slaughter Wraith's Resonance": tempestofsetidolofset,
    "Soul Absorption":necromancersoulabsorption,
    "Soul Frost":necromancersoulfrost,
    "Supreme Lich":necromancersupremelich,
    "Tome of Epithur":necromancertomeofepithur,
    "Touch of Winter":necromancertouchofwinter,
    "Undead Champion: Slaughter Wraith":necromancerundeadchampionslaughterwraith,
    "Undead Minion: Blighted One":necromancerundeadminionblightedone,
    "Undead Minion: Corruptor":necromancerundeadminioncorruptor,
    "Undead Minion: Harvester":necromancerundeadminionharvester,
    "Undead Minion: Life-Stealer":necromancerundeadminionlifestealer,
    "Undead Minion: Mutilator":necromancerundeadminionmutilator,
    "Undead Minion: Necrotic Bomb":necromancerundeadminionnecroticbomb,
    "Unholy Hands":necromancerunholyhands,
    "Unimaginable Terror":necromancerunimaginableterror,
    "Void":necromancervoid,
    "Walk with Death":necromancerwalkwithdeath,
    "Withered Blasphemy":necromancerwitheredblasphemy,
    "Withered Soul":necromancerwitheredsoul,
    "Wretched Heart Curse":necromancerwretchedheartcurse,
  },
  //priestofmitra
  "Priest of Mitra":{
    "Armor of Faith":priestofmitraarmoroffaith,
    "Avatar of Mitra":priestofmitraavatarofmitra,
    "Avert Thine Eyes":priestofmitraavertthineeyes,
    "Blessed Soul":priestofmitrablessedsoul,
    "Blessing of Mitra":priestofmitrablessingofmitra,
    "Blistering Wounds":priestofmitrablisteringwounds,
    "Brilliance": priestofmitrasoulofmitra,
    "Clarity of Mind":priestofmitraclarityofmind,
    "Cleansing Fire":priestofmitracleansingfire,
    "Condemn":priestofmitracondemn,
    "Condemnation":priestofmitracondemnation,
    "Devotional Prayer":priestofmitradevotionalprayer,
    "Divine Blessing":priestofmitradivineblessing,
    "Divine Vigor":priestofmitradivinevigor,
    "Emanation of Life":priestofmitraemanationoflife,
    "Emissary of Elysium":priestofmitraemissaryofelysium,
    "Exorcism":priestofmitraexorcism,
    "Eye of Judgment":priestofmitraeyeofjudgment,
    "Glowing Radiance":priestofmitraglowingradiance,
    "Guardian Spirit":priestofmitraguardianspirit,
    "Hand of Mitra":priestofmitrahandofmitra,
    "Holy Accession":priestofmitraholyaccession,
    "Holy Cleansing":priestofmitraholycleansing,
    "Holy Storm":priestofmitraholystorm,
    "Holy Vengeance":priestofmitraholyvengeance,
    "Immortal Wrath":priestofmitraimmortalwrath,
    "Inclusion":priestofmitrainclusion,
    "Inspiring Light":priestofmitrainspiringlight,
    "Lance of Mitra":priestofmitralanceofmitra,
    "Light of Mitra":priestofmitralightofmitra,
    "Light the Path":priestofmitralightthepath,
    "Litany of Protection":priestofmitralitanyofprotection,
    "Manifestation of Mitra":priestofmitramanifestationofmitra,
    "Mitra's Searing Eye":priestofmitramitrassearingeye,
    "Purification of Mitra":priestofmitrapurificationofmitra,
    "Purifying Light":priestofmitrapurifyinglight,
    "Radiance":priestofmitraradiance,
    "Rebuke":priestofmitrarebuke,
    "Reciprocal Healing":priestofmitrareciprocalhealing,
    "Reincarnation":priestofmitrareincarnation,
    "Rejuvenating Light":priestofmitrarejuvenatinglight,
    "Repudiate":priestofmitrarepudiate,
    "Repulse":priestofmitrarepulse,
    "Sacred Fire":priestofmitrasacredfire,
    "Sacred Smite":priestofmitrasacredsmite,
    "Searing Light":priestofmitrasearinglight,
    "Shield of Brilliance":priestofmitrashieldofbrilliance,
    "Shimmering Invocation":priestofmitrashimmeringinvocation,
    "Smite":priestofmitrasmite,
    "Soul of Mitra":priestofmitrasoulofmitra,
    "Spiritual Feedback":priestofmitraspiritualfeedback,
    "Sustaining the Faith":priestofmitrasustainingthefaith,
    "Wandering Disciple":priestofmitrawanderingdisciple,
    "Wave of Life":priestofmitrawaveoflife,
  },
  //ranger
  Ranger:{
    "Advangtage: Absolute Precision":rangeradvangtageabsoluteprecision,
    "Advantage: Fire Attack":rangeradvantagefireattack,
    "Advantage: Focused Fire":rangeradvantagefocusedfire,
    "Advantage: Misdirection":rangeradvantagemisdirection,
    "Advantage: Recuperation":rangeradvantagerecuperation,
    "Advantage: Sharpened Weapons":rangeradvantagesharpenedweapons,
    "Advantage: Shattering Attack":rangeradvantageshatteringattack,
    "Armor Ripper I":rangerarmorripper1,
    "Armor Ripper II":rangerarmorripper2,
    "Armor Ripper III":rangerarmorripper3,
    "Bleeding Puncture I":rangerbleedingpuncture1,
    "Bleeding Puncture II":rangerbleedingpuncture2,
    "Bleeding Puncture III":rangerbleedingpuncture3,
    "Bleeding Puncture IV":rangerbleedingpuncture4,
    "Booby Trap":rangerboobytrap,
    "Clout":rangerclout,
    "Concussive Blast":rangerconcussiveblast,
    "Cripple I":rangercripple1,
    "Cripple II":rangercripple2,
    "Cripple III":rangercripple3,
    "Crossfire":rangercrossfire,
    "Deadly Draw":rangerdeadlydraw,
    "Deft Stabs I":rangerdeftstabs1,
    "Deft Stabs II":rangerdeftstabs2,
    "Deft Stabs III":rangerdeftstabs3,
    "Evasive Action":rangerevasiveaction,
    "Exhausting Traps":rangerexhaustingtraps,
    "Fancy Footwork":rangerfancyfootwork,
    "Fire Trap":rangerfiretrap,
    "Flame Barrage":rangerflamebarrage,
    "Hunting Hawk":rangerhuntinghawk,
    "Immolation":rangerimmolation,
    "Incendiary Shot":rangerincendiaryshot,
    "Jarring Shot":rangerjarringshot,
    "Leghold Trap":rangerlegholdtrap,
    "Linebreaker":rangerlinebreaker,
    "Marked for Death":rangermarkedfordeath,
    "Marked Target":rangermarkedtarget,
    "Master Trapper":rangermastertrapper,
    "Penetrating Shot I":rangerpenetratingshot1,
    "Penetrating Shot II":rangerpenetratingshot2,
    "Penetrating Shot III":rangerpenetratingshot3,
    "Penetrating Shot IV":rangerpenetratingshot4,
    "Penetrating Shot V":rangerpenetratingshot5,
    "Pin Down I":rangerpindown1,
    "Pin Down II":rangerpindown2,
    "Pin Down III":rangerpindown3,
    "Pin Down IV":rangerpindown4,
    "Pitch Pot":rangerpitchpot,
    "Pitch Pot's Burning Pitch":rangerpitchpot,
    "Point Blank Shot":rangerpointblankshot,
    "Puncture":rangerpuncture,
    "Quick Shot I":rangerquickshot1,
    "Quick Shot II":rangerquickshot2,
    "Quick Shot III":rangerquickshot3,
    "Quick Shot IV":rangerquickshot4,
    "Quick Shot V":rangerquickshot5,
    "Recently Used Advantage":rangerrecentlyusedadvantage,
    "Rending Strikes":rangerrendingstrikes,
    "Running Shot":rangerrunningshot,
    "Shield Bash":rangershieldbash,
    "Sulfurous Burst":rangersulfurousburst,
    "Tracking":rangertracking,
    "Vigor":rangervigor,
  },
  //tempestofset
  "Tempest of Set":{
    "Aura of Nebthu":tempestofsetsummonauraofnebthu,
    "Blood Mana":tempestofsetbloodmana,
    "Call Lightning":tempestofsetcalllightning,
    "Charged Blast":tempestofsetchargedblast,
    "Coalesce Ether":tempestofsetcoalesceether,
    "Cobra Snare":tempestofsetcobrasnare,
    "Coils of the Serpent":tempestofsetcoilsoftheserpent,
    "Column Lightning":tempestofsetcolumnlightning,
    "Constriction":tempestofsetconstriction,
    "Curse of Set":tempestofsetcurseofset,
    "Cyclone of Set":tempestofsetcycloneofset,
    "Damnation of Set":tempestofsetdamnationofset,
    "Elemental Fury":tempestofsetelementalfury,
    "Eye of the Storm":tempestofseteyeofthestorm,
    "Eyes of Set":tempestofseteyesofset,
    "Faithful of Set":tempestofsetfaithfulofset,
    "Faith in Set":tempestofsetfaithinset,
    "Fangs of Set":tempestofsetfangsofset,
    "Force of Lightning":tempestofsetforceoflightning,
    "Forked Lightning":tempestofsetforkedlightning,
    "Glorification of Set":tempestofsetglorificationofset,
    "Growing Storm":tempestofsetgrowingstorm,
    "Healing Lotus":tempestofsethealinglotus,
    "Idol of Dark Rejuvenation":tempestofsetidolofdarkrejuvenation,
    "Idol of Dark Rejuvenation's Idol of Dark Rejuvenation":tempestofsetidolofdarkrejuvenation,
    "Idol of Set":tempestofsetidolofset,
    "Idol of Set's Charge Stone":tempestofsetidolofset,
    "Idol of Set's Storm Charge":tempestofsetstormcharge,
    "Idol of Set's Resonance":tempestofsetidolofset,
    "Idol of Set's Storm Field":tempestofsetstormfield,
    "Inner Charge":tempestofsetinnercharge,
    "Leviathan's Call":tempestofsetleviathanscall,
    "Life of Set":tempestofsetlifeofset,
    "Lightning Arc":tempestofsetlightningarc,
    "Lightning Cast":tempestofsetlightningcast,
    "Lightning Sparks":tempestofsetlightningsparks,
    "Lightning Storm Nimbus":tempestofsetlightningstormnimbus,
    "Lightning Strikes":tempestofsetlightningstrikes,
    "Lightning Strike":tempestofsetlightningstrikes,
    "Lull":tempestofsetlull,
    "Mark of Set":tempestofsetmarkofset,
    "Overcharge":tempestofsetovercharge,
    "Power of the Serpent Ring":tempestofsetpoweroftheserpentring,
    "Puppets of Set":tempestofsetpuppetsofset,
    "Quicksand":tempestofsetquicksand,
    "Rousing Shock":tempestofsetrousingshock,
    "Serpent Transmutation":tempestofsetserpenttransmutation,
    "Set's Life Spark":tempestofsetsetslifespark,
    "Slip Free":tempestofsetslipfree,
    "Spark of Life":tempestofsetsparkoflife,
    "Spark Storm":tempestofsetsparkstorm,
    "Staggering Voice":tempestofsetstaggeringvoice,
    "Static Blood":tempestofsetstaticblood,
    "Storm Blood":tempestofsetstormblood,
    "Storm Charge":tempestofsetstormcharge,
    "Storm Crown":tempestofsetstormcrown,
    "Storm Field":tempestofsetstormfield,
    "Storm Nimbus":tempestofsetstormnimbus,
    "Storm Regalia":tempestofsetstormregalia,
    "Summon Aura of Nebthu":tempestofsetsummonauraofnebthu,
    "Thundering Voice":tempestofsetthunderingvoice,
    "Triumphant Life of Set":tempestofsettriumphantlifeofset,
    "Vengeful Idol of Set's Vengeful Idol of Set": tempestofsetidolofset,
    "Vitalizing Jolt":tempestofsetvitalizingjolt,
    "Vital Shock":tempestofsetvitalshock,
    "Wrath of the Serpent Ring":tempestofsetwrathoftheserpentring,
  },
}

export function getAbility(ability: string | undefined, classType: string | undefined) {
  if(ability == undefined)
    return NotFound;
  let adjustedAbility = ability.replace(/( \(Rank [0-9]+\))/g,'').replace(/( \([0-9]+\))/g,'').replace(/( \(Finesse\))/g,'');
  
  let foundValue = null;
  let _abilities:any = {};
  if(classType != null && classType != undefined && classType != ""){
    _abilities = {...AbilityIcons};
  }else{
    Object.keys(AbilityIcons).forEach((key)=>{
      _abilities[key] = AbilityIcons[key];
    })
    _abilities = {..._abilities, ...AbilityIcons["Assassin"], ...AbilityIcons["Barbarian"], ...AbilityIcons["Ranger"], ...AbilityIcons["Priest of Mitra"], ...AbilityIcons["Tempest of Set"], ...AbilityIcons["Bear Shaman"], ...AbilityIcons["Demonologist"], ...AbilityIcons["Necromancer"], ...AbilityIcons["Herald of Xotli"], ...AbilityIcons["Guardian"], ...AbilityIcons["Conqueror"], ...AbilityIcons["Dark Templar"]};
  }
  let keys = Object.keys(_abilities);
  for(var i = 0; i < keys.length; i++){
    let temp = null;
    if(typeof _abilities[keys[i]] === 'object' && _abilities[keys[i]] !== null && keys[i] == classType){
      temp = _abilities[keys[i]][adjustedAbility];
    }else{
      temp = keys[i] == adjustedAbility ? _abilities[keys[i]] : null;
    }
    if(temp){
      foundValue = temp;
      break;
    }
  }
  if(!foundValue)
    foundValue = NotFound;
  return foundValue;
}

export function getClass(ability: string | undefined) {
  if(ability == undefined)
    return null;
  let adjustedAbility = ability.replace(/( \(Rank [0-9]+\))/g,'').replace(/( \([0-9]+\))/g,'').replace(/( \(Finesse\))/g,'');
  let keys = Object.keys(AbilityIcons).filter((key)=>["Assassin","Barbarian","Ranger","Priest of Mitra","Tempest of Set","Bear Shaman","Demonologist","Necromancer","Herald of Xotli","Guardian","Conqueror","Dark Templar"].includes(key));
  let foundValue = null;
  for(var i = 0; i < keys.length; i++){
    let temp = null;
    if(typeof AbilityIcons[keys[i]] === 'object' && AbilityIcons[keys[i]] !== null){
      temp = AbilityIcons[keys[i]][adjustedAbility];
    }else{
      temp = null
    }
    if(temp){
      foundValue = keys[i];
      break;
    }
  }
  return foundValue;
}

export function getAllAbilities() {
  let keys = Object.keys(AbilityIcons);
  let abilities = [];
  for(var i = 0; i < keys.length; i++){
    if(typeof AbilityIcons[keys[i]] === 'object' && AbilityIcons[keys[i]] !== null){
      let tempKeys = Object.keys(AbilityIcons[keys[i]]);
      for(var k = 0; k < tempKeys.length; k++){
        abilities.push(AbilityIcons[keys[i]][tempKeys[k]]);
      }
    }else{
      abilities.push(AbilityIcons[keys[i]]);
    }
    
  }
  return abilities;
}